<template>
    <div class="hello-page-wrapper">
        <div class="theme-bg-img" :class="selectedTheme">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="main-content text-left left-content">
                            <hr>
                            <span v-if="newContentLoaded">
                            <h1><strong>Surprise!!</strong> We found new content for you</h1>
                                </span>
                            <span v-if="user && user.firstName">
                                <h2>
                                    <span v-if="getAuthGreeting">{{getAuthGreeting}}</span><br/>
                                    <b>{{user.firstName}}</b>, here are some videos we think you'll love.
                            </h2>
                            </span>
                            <span v-else>
                                <h2>
                                     <span v-if="getAuthGreeting">{{getAuthGreeting}}</span> <br/>
                               	     Here are some videos we think you'll love.
				                </h2>
                            </span>
                        </div>
                    </div>
                    <div class="left-panel clearfix col-xs-12 col-sm-12 col-md-8" v-if="getAuthRecommendedVideos">
                        <div class="coloredpannel">
                            <a :href="'/watch/' + getAuthRecommendedVideos[0].mediaid + '/' + getAuthRecommendedVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                <div class="image-container">
                                    <img class="jw-img-1" :src="getAuthRecommendedVideos[0].image" :alt="getAuthRecommendedVideos[0].title" :title="getAuthRecommendedVideos[0].title" />
                                    <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(getAuthRecommendedVideos[0].duration) }}</p>
                                </div>
                            </a>
                            <div class="panel panel-default">
                                <h1 class="cursor" @click="setVideoPlayerObject(getAuthRecommendedVideos[0].mediaid, getAuthRecommendedVideos[0].title)"> <i class="fa fa-play-circle-o"></i> {{getAuthRecommendedVideos[0].title}}</h1>
                                <p>{{getAuthRecommendedVideos[0].description}}</p>
                                <div class="panel-footer">
                                    <!--<div class="text-left text-like">-->
                                    <!--<div v-if="getVideoStatus(getAuthRecommendedVideos[0])">-->
                                    <!--<span>-->
                                    <!--You love this-->
                                    <!--</span>-->
                                    <!--<span class="icon-like">-->
                                    <!--<i class="fa fa-heart fa-2x activeIcons" aria-hidden="true"></i>-->
                                    <!--</span>-->
                                    <!--</div>-->
                                    <!--<div v-else>-->
                                    <!--<span>-->
                                    <!--&nbsp;-->
                                    <!--</span>-->
                                    <!--<span class="icon-like">-->
                                    <!--<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>-->
                                    <!--</span>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                </div>
                            </div>
                            <div class="panel panel-default high-lighter responsive-social-icons hidemobile" v-if="getQuote">
                                <h2>
                                    " {{getQuote.quote}} " <br>
                                </h2><h4>({{getQuote.author}})</h4>
                                <div class="container-icons">
                                    <social-sharing  v-bind:url="videoURL" v-bind:quote = "quoteReference" v-bind:description = "quoteReference" v-bind:title = "quoteReference" inline-template>
                                        <div>
                                            <network network="facebook">
                                                <i class="fa fa-2x fa-facebook cursor"></i>
                                            </network>
                                            <network network="twitter">
                                                <i class="fa fa-2x fa-twitter cursor"></i>
                                            </network>
                                            <network network="linkedin" class="holder">
                                                <i class="fa fa-2x fa-linkedin cursor"></i>
                                            </network>
                                            <network network="email" class="holder">
                                                <i class="fa fa-2x fa-envelope cursor"></i>
                                            </network>
                                        </div>
                                    </social-sharing>
                                </div>
                                <!--<div class="container-icons">-->
                                <!--<a href="javascript:">-->
                                <!--<i class="fa fa-facebook fa-2x " aria-hidden="true"></i>-->
                                <!--</a>-->
                                <!--<a href="javascript:">-->
                                <!--<i class="fa fa-twitter fa-2x " aria-hidden="true"></i>-->
                                <!--</a>-->
                                <!--<a href="javascript:">-->
                                <!--<i class="fa fa-pinterest-p fa-2x " aria-hidden="true"></i>-->
                                <!--</a>-->
                                <!--</div>-->
                            </div>
                        </div>
                    </div>
                    <div class="right-panel clearfix col-xs-12 col-sm-12 col-md-4 pull-right" v-if="getAuthRecommendedVideos">
                        <!--<jwplayer :data="player2">Loading the player...</jwplayer> -->
                        <div class="shadowdrop"  v-if="getAuthRecommendedVideos">
                            <a :href="'/watch/' + getAuthRecommendedVideos[1].mediaid + '/' + getAuthRecommendedVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                <div class="image-container">
                                    <img class="jw-img-1" :src="getAuthRecommendedVideos[1].image"  :alt="getAuthRecommendedVideos[1].title" :title="getAuthRecommendedVideos[1].title"/>
<p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(getAuthRecommendedVideos[1].duration) }}</p>
                                </div>
                            </a>
                            <div class="panel panel-default">
                                <h4 class="cursor" @click="setVideoPlayerObject(getAuthRecommendedVideos[1].mediaid, getAuthRecommendedVideos[1].title)"> <i class="fa fa-play-circle-o"></i> {{getAuthRecommendedVideos[1].title}}</h4>
                                <p>{{getAuthRecommendedVideos[1].description}}</p>
                                <div class="panel-footer">
                                    <!--<div class="text-left text-like">-->
                                    <!--<div v-if="getVideoStatus(getAuthRecommendedVideos[1])">-->
                                    <!--<span class="text-muted">-->
                                    <!--You love this-->
                                    <!--</span>-->
                                    <!--<span class="icon-like">-->
                                    <!--<i class="fa fa-heart fa-2x activeIcons" aria-hidden="true"></i>-->
                                    <!--</span>-->
                                    <!--</div>-->
                                    <!--<div v-else>-->
                                    <!--<span>-->
                                    <!--&nbsp;-->
                                    <!--</span>-->
                                    <!--<span class="icon-like">-->
                                    <!--<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>-->
                                    <!--</span>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="shadowdrop" v-if="getAuthRecommendedVideos[2]">
                            <a :href="'/watch/' + getAuthRecommendedVideos[2].mediaid + '/' + getAuthRecommendedVideos[2].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                <div class="image-container">
                                    <img class="jw-img-1" :src="getAuthRecommendedVideos[2].image"  :alt="getAuthRecommendedVideos[2].title" :title="getAuthRecommendedVideos[2].title" />
                                    <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(getAuthRecommendedVideos[2].duration) }}</p>
                                </div>
                            </a>
                            <div class="panel panel-default">
                                <h4 class="cursor" @click="setVideoPlayerObject(getAuthRecommendedVideos[2].mediaid, getAuthRecommendedVideos[2].title)"> <i class="fa fa-play-circle-o"></i> {{getAuthRecommendedVideos[2].title}}</h4>
                                <p>{{getAuthRecommendedVideos[2].description}}</p>
                                <div class="panel-footer">
                                    <!--<div class="text-left text-like">-->
                                    <!--<div v-if="getVideoStatus(getAuthRecommendedVideos[2])">-->
                                    <!--<span class="text-muted">-->
                                    <!--You love this-->
                                    <!--</span>-->
                                    <!--<span class="icon-like">-->
                                    <!--<i class="fa fa-heart fa-2x activeIcons" aria-hidden="true"></i>-->
                                    <!--</span>-->
                                    <!--</div>-->
                                    <!--<div v-else>-->
                                    <!--<span>-->
                                    <!--&nbsp;-->
                                    <!--</span>-->
                                    <!--<span class="icon-like">-->
                                    <!--<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>-->
                                    <!--</span>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                </div>
                            </div>
                        </div>
                        <br>
                        <div>
                            <div class="row">
                                <div class="panel panel-default interest-mood" :class="{ hidden: showQuestionsBox }">
                                    <div class="row">
                                        <div class="col-xs-7 col-md-7 extra-small">
                                            <h4>
                                                In the mood for <br>
                                                something else
                                            </h4>
                                        </div>
                                        <div class="col-xs-5 col-md-5">
                                            <button @click="showQuestions" type="button" class="btn btn-lg btn-transparent">Yes
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if = "getAuthQuestions" class="col-md-12" :class="{ hidden: !showQuestionsBox }">
                                    <div class="questions-content" >
                                        <div v-for="question in getAuthQuestions">
                                            <button type="button" @click="setAnswer(question.questionId)">
                                                <span>{{question.question}}</span>
                                            </button>
                                        </div>
                                        <span class="no-thanks"><a href="javascript:" @click="showQuestions">no thanks</a></span>
                                    </div>
                                    <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="left-panel clearfix col-xs-12 col-sm-12 col-md-8">
                        <div class="panel panel-default high-lighter responsive-social-icons showMobile" v-if="getQuote">
                            <h2>
                                " {{getQuote.quote}} " <br>
                            </h2><h4>({{getQuote.author}})</h4>
                            <div class="container-icons">
                                <social-sharing  v-bind:url="videoURL" v-bind:quote = "quoteReference" v-bind:description = "quoteReference" v-bind:title = "quoteReference" inline-template>
                                    <div>
                                        <network network="facebook">
                                            <i class="fa fa-2x fa-facebook cursor"></i>
                                        </network>
                                        <network network="twitter">
                                            <i class="fa fa-2x fa-twitter cursor"></i>
                                        </network>
                                        <network network="linkedin" class="holder">
                                            <i class="fa fa-2x fa-linkedin cursor"></i>
                                        </network>
                                        <network network="email" class="holder">
                                            <i class="fa fa-2x fa-envelope cursor"></i>
                                        </network>
                                    </div>
                                </social-sharing>
                            </div>
                            <!--<div class="container-icons">-->
                            <!--<a href="javascript:">-->
                            <!--<i class="fa fa-facebook fa-2x " aria-hidden="true"></i>-->
                            <!--</a>-->
                            <!--<a href="javascript:">-->
                            <!--<i class="fa fa-twitter fa-2x " aria-hidden="true"></i>-->
                            <!--</a>-->
                            <!--<a href="javascript:">-->
                            <!--<i class="fa fa-pinterest-p fa-2x " aria-hidden="true"></i>-->
                            <!--</a>-->
                            <!--</div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="charity" id="auth_giving_scroll">
            <div class="container">
                <!--<div class="row visible-xs">-->
                <!--<div class="col-md-12">-->
                <!--<div class="charity-header">-->
                <!--<div class="title">-->
                <!--<h2>CLICKS FOR GOOD</h2>-->
                <!--</div>-->
                <!--<div class="desc">-->
                <!--<p>Select your charity and start doing good with the time you spend at Tone.</p>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--&lt;!&ndash;<div class="col-md-12" v-if="getAllCharities" style="text-align:center">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="slider charity-slick-slider" style="text-align:center">&ndash;&gt;-->
                <!--&lt;!&ndash;<div v-for="charity in getAllCharities">&ndash;&gt;-->
                <!--&lt;!&ndash;<img v-bind:src="charity.img_url"   alt="LOGO" v-bind:title= "charity.title">&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
                <!--</div>-->
                <!--<div class="row text-center" v-if="getAllCharities">-->
                <!--<div class="col-md-12">-->
                <!--<div class="charity-header">-->
                <!--<div class="title">-->
                <!--<h2>CLICKS FOR GOOD</h2>-->
                <!--</div>-->
                <!--<div class="desc">-->
                <!--<p>Select your charity and start doing good with the time you spend at Tone.</p>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--<div class="charity-section-img" v-for="(charity, index)  in getAllCharities">-->
                <!--<div :class="{-->
                <!--'col-md-12': getAllCharities.length === 1,-->
                <!--'col-md-6': getAllCharities.length === 2,-->
                <!--'col-md-4': getAllCharities.length === 3,-->
                <!--'col-md-3': getAllCharities.length === 4,-->
                <!--'col-sm-6': getAllCharities.length === 1 || getAllCharities.length === 2 || getAllCharities.length === 3 || getAllCharities.length === 4 || getAllCharities.length === 5,-->
                <!--'charity-5': getAllCharities.length === 5}"-->
                <!--&gt;-->
                <!--<img v-bind:src="charity.img_url"   alt="LOGO" v-bind:title= "charity.title">-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <div class="row" v-if="getAllCharities">
                    <div class="col-md-12">
                        <div class="content charity-content">
                            <div class="slider responsive-slick-charity-slider">
                                <!-- div>
                                    <div class="charity-header margin-bottom-20">
                                        <div class="title" v-bind:style="{ color: getCorpHeadingColor } ">
                                            <h2>Your Daily Dose of Funny</h2>
                                        </div>
                                        <div class="desc">
                                        </div>
                                    </div>
                                    <div class="funnies-img smallslide" v-if="getAuthFunnies">
                                        <img v-bind:src="getAuthFunnies" v-bind:title= "getAuthFunnies" alt="TONE Smiles" title="TONE Smiles">
                                    </div>
                                </div -->
                                <!--Charity Section commented 537-->
                                <!--<div>-->
                                <!--<div class="charity-header">-->
                                <!--<div class="title">-->
                                <!--<h2>CLICKS FOR GOOD</h2>-->
                                <!--</div>-->
                                <!--<div class="desc">-->
                                <!--<p>Select your charity and start doing good with the time you spend at Tone.</p>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="charity-section-img" v-for="(charity, index)  in getAllCharities">-->
                                <!--<div :class="{-->
                                <!--'col-md-12': getAllCharities.length === 1,-->
                                <!--'col-md-6': getAllCharities.length === 2,-->
                                <!--'col-md-4': getAllCharities.length === 3,-->
                                <!--'col-md-3': getAllCharities.length === 4,-->
                                <!--'col-sm-6': getAllCharities.length === 1 || getAllCharities.length === 2 || getAllCharities.length === 3 || getAllCharities.length === 4 || getAllCharities.length === 5,-->
                                <!--'charity-5': getAllCharities.length === 5}"-->
                                <!--&gt;-->
                                <!--<img v-bind:src="charity.img_url"   alt="LOGO" v-bind:title= "charity.title">-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="margin-bottom-40">-->
                                <!--<div class="col-md-12">-->
                                <!--<button @click="redirectToGiving()" class="btn btn-danger charity-btn btn-transparent btn-lg">Choose My Charity</button>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--TONE live section-->
                                <div class="row imgbalnace" v-if="firstLiveEvent">
                                    <div class="charity-header margin-bottom-20 ">
                                        <div class="title" v-bind:style="{ color: getCorpHeadingColor } ">
                                            <h2>TONE Live: {{getDateReference(firstLiveEvent.start_date, 'str')}}</h2>
                                        </div>
                                        <div class="desc">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <jwplayer v-if="currentVideo" :data="currentVideo">Loading the player...</jwplayer>
                                        <img v-if="!currentVideo" class="jw-img" :src="firstLiveEvent.img_url" alt="EXPERTS" width="100%" :alt="firstLiveEvent.title" :title="firstLiveEvent.title" >
                                    </div>
                                    <div class="col-md-6">
                                        <div class="experts">
                                            <h2>{{firstLiveEvent.title}} </h2>
                                            <p>
                                                {{firstLiveEvent.longDescription}}
                                            </p>
                                            <br>
                                            <p class="date">
                                                {{getDateReference(firstLiveEvent.start_date, 'str')}}
                                            </p>
                                            <br>
                                            <div  v-on:click="calendarLogging($event, firstLiveEvent.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(firstLiveEvent.eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                                Add to Calendar
                                                <span class="start">{{firstLiveEvent.start_date}}</span>
                                                <span class="end">{{firstLiveEvent.end_date}}</span>
                                                <span class="timezone">America/New_York</span>
                                                <span class="title">{{firstLiveEvent.title}}</span>
                                                <span class="description">{{firstLiveEvent.longDescription}}</span>
                                                <span class="location">{{buildEventLink (firstLiveEvent.eventId) }}</span>
                                            </div>
                                            <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(firstLiveEvent)" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                                <i class="fa fa-share-square-o"></i> Share
                                            </button>
                                            <div class="clearfix>"></div>
                                            <button class="btn-pink" type="button" v-if="showJoin(firstLiveEvent.eventId)" @click="joinEvent(firstTalkEvent)" :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>
                                            <!--<button class="btn-pink" v-if="!isUserEntrolled(firstTalkEvent.eventId) && isEventToday(firstTalkEvent.start_date, firstTalkEvent.end_date) === false" @click="enrollUser(firstTalkEvent)" type="button">Reserve your spot</button>-->
                                            <!--<br>-->
                                            <!--<button class="btn btn-danger expert-section-btn btn-transparent btn-lg">Reserve a Seat at the Table</button>-->
                                        </div>
                                    </div>
                                </div>
                                <!--TONE Talk section-->
                                <div class="row imgbalnace" v-if="firstTalkEvent">
                                    <div class="charity-header margin-bottom-20">
                                        <div class="title" v-bind:style="{ color: getCorpHeadingColor } ">
                                            <h2>TONE Talk: {{getDateReference(firstTalkEvent.start_date, 'str')}}</h2>
                                        </div>
                                        <div class="desc">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <img class="jw-img" :src="firstTalkEvent.img_url" alt="EXPERTS" width="100%" :alt="firstTalkEvent.title" :title="firstTalkEvent.title" >
                                    </div>
                                    <div class="col-md-6">
                                        <div class="experts">
                                            <h2>{{firstTalkEvent.title}} </h2>
                                            <p>
                                                {{firstTalkEvent.longDescription}}
                                            </p>
                                            <br>
                                            <p class="date">
                                                {{getDateReference(firstTalkEvent.start_date, 'str')}}
                                            </p>
                                            <br>
                                            <div v-on:click="calendarLogging($event, firstTalkEvent.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(firstTalkEvent.eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                                Add to Calendar
                                                <span class="start">{{firstTalkEvent.start_date}}</span>
                                                <span class="end">{{firstTalkEvent.end_date}}</span>
                                                <span class="timezone">America/New_York</span>
                                                <span class="title">{{firstTalkEvent.title}}</span>
                                                <span class="description">{{firstTalkEvent.longDescription}}</span>
                                                <span class="location">{{buildEventLink (firstTalkEvent.eventId) }}</span>
                                            </div>
                                            <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(firstTalkEvent)" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                                <i class="fa fa-share-square-o"></i> Share
                                            </button>
                                            <div class="clearfix>"></div>
                                            <button class="btn-pink" type="button" v-if="showJoin(firstTalkEvent.eventId)" @click="joinEvent(firstTalkEvent)" :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>
                                            <br>
                                            <!--<button class="btn-pink" v-if="!isUserEntrolled(firstTalkEvent.eventId) && isEventToday(firstTalkEvent.start_date, firstTalkEvent.end_date) === false" @click="enrollUser(firstTalkEvent)" type="button">Reserve your spot</button>-->
                                            <!--<br>-->
                                            <!--<button class="btn btn-danger expert-section-btn btn-transparent btn-lg">Reserve a Seat at the Table</button>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="row margin-bottom-40">-->
                <!--<div class="col-md-12">-->
                <!--<button @click="redirectToGiving()" class="btn btn-danger charity-btn btn-transparent btn-lg">Choose My Charity</button>-->
                <!--</div>-->
                <!--</div>-->
            </div>
        </div>
        <div class="recently-watched" v-if="getAuthRecentlyWatchedVideos">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2>RECENTLY WATCHED</h2>
                    </div>
                    <div class="col-md-12">
                        <div class="content">
                            <div class="slider responsive-slick-slider">
                                <div v-for = "reccentVideo in getAuthRecentlyWatchedVideos">
                                    <div class="slide-player">
                                        <a :href="'/watch/' + reccentVideo.mediaid + '/' + reccentVideo.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                            <div class="image-container">
                                                <img class="jw-img-1" :src="reccentVideo.image" :alt="reccentVideo.title" :title="reccentVideo.title" />
                                                <p class="text-wrap-title-1 recent-style cursor">{{ formattedDuration(reccentVideo.duration) }}</p>
                                            </div>
                                            <p  class="text-wrap-title cursor postion-title">
                                                <i class="fa fa-play-circle-o"></i> {{reccentVideo.title}}
                                            </p>
                                        </a>
                                        <hr>
                                        <!--<div class="plusicon btn-group">-->
                                        <!--<button title="Add to Playlist" :id="reccentVideo.mediaid" type="button" @click="showPlaylistMenu(reccentVideo.mediaid)" class="dropdown-toggle ellipsis pull-right">-->
                                        <!--<i class="fa fa-plus"></i>-->
                                        <!--</button>-->
                                        <!--<ul class="hide">-->
                                        <!--<li  v-if="getUserPlaylists">-->
                                        <!--<label>-->
                                        <!--<b> Add to ...</b>-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--<li role="separator" class="divider"  v-if="getUserPlaylists"></li>-->
                                        <!--<li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">-->
                                        <!--<label>-->
                                        <!--<input type="checkbox" :checked="verifyVideoExists(playlist, reccentVideo)" @click="setPlaylistVideoStatus(reccentVideo, playlist, verifyVideoExists(playlist, reccentVideo)) "/> {{playlist.title}}-->
                                        <!--</label>-->
                                        <!--</li>-->
                                        <!--&lt;!&ndash;<li>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<label>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<input type="checkbox" /> Second option&ndash;&gt;-->
                                        <!--&lt;!&ndash;</label>&ndash;&gt;-->
                                        <!--&lt;!&ndash;</li>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<li>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<label>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<input type="checkbox" /> Third option&ndash;&gt;-->
                                        <!--&lt;!&ndash;</label>&ndash;&gt;-->
                                        <!--&lt;!&ndash;</li>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<li>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<label>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<input type="checkbox" /> Forth option&ndash;&gt;-->
                                        <!--&lt;!&ndash;</label>&ndash;&gt;-->
                                        <!--&lt;!&ndash;</li>&ndash;&gt;-->
                                        <!--<li role="separator" class="divider" v-if="getUserPlaylists"></li>-->
                                        <!--<li><label style="color:#f0617d">+ Create new playlist</label></li>-->
                                        <!--<li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />-->
                                        <!--<i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>-->

                                        <!--</label> </li>-->
                                        <!--</ul>-->
                                        <!--<div class="backdropformenu"  @click="hidePlaylistMenu(reccentVideo.mediaid)"></div>-->
                                        <!--</div>-->
                                        <p class="right-heart-icon">
                                            <a href="javascript:" @click="setVideoStatus(reccentVideo)" title ="Liked this video?" style="outline: none;">
                                                <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                   v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" ></i></a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <button @click="setRecentlyWatchedVideos()" class="btn btn-danger recently-watched-btn btn-transparent btn-lg" :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)">View All Your Videos</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <section class="applicationdownload" :class="{ hidden: isHidden() }">
            <img class="showmobile" src="https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-new.png" alt="DOWNLOAD TONE APP" title="Download TONE App">
            <h2><b>Get TONE on your Phone with the TONE app</b></h2>
            <a target="_blank" href="https://apps.apple.com/us/app/tone-networks-advice-on-demand/id1444962883?ls=1"><img class="appbtn" src="https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-apple.png" alt="DOWNLOAD APPLE APP" title="Download App on IOS"></a>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.tonenetworks.toneapp"><img class="appbtn" src="https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/mobile-app-android.png" alt="DOWNLOAD ANDROID APP" title="Download App on Android"></a>
        </section>
        <div class="expert-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h2>EVENTS</h2>
                    </div>
                </div>
                <div class="row margin-top-40">
                    <div class="col-md-12">
                        <tabs class="expert-tabs" v-model="activeTab" nav-style="tabs" justified>
                            <!--<tab header="What is it?" >-->
                            <!--<div class="row">-->
                            <!--<div class="col-md-6">-->
                            <!--<img :src="whatIsItImage" alt="COMMMUNITY" width="100%">-->
                            <!--</div>-->
                            <!--<div class="col-md-6">-->
                            <!--<div class="experts">-->
                            <!--<h2>{{whatIsItHeading}}</h2>-->
                            <!--<br />-->
                            <!--<p>-->
                            <!--{{whatIsItText}}-->
                            <!--</p>-->
                            <!--<br>-->
                            <!--&lt;!&ndash;<p class="date">&ndash;&gt;-->
                            <!--&lt;!&ndash;Monday, June 23rd @9AM&ndash;&gt;-->
                            <!--&lt;!&ndash;</p>&ndash;&gt;-->
                            <!--&lt;!&ndash;<br>&ndash;&gt;-->
                            <!--&lt;!&ndash;<button class="btn btn-danger expert-section-btn btn-transparent btn-lg">Reserve a Seat at the Table</button>&ndash;&gt;-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</tab>-->
                            <tab header="TONE Live" v-if="firstLiveEvent"  >
                                <div class="row">
                                    <div class="col-md-6">
                                        <!--<img class="jw-img" :src="liveEventExpert.small_image" alt="EXPERTS" width="100%" >-->
                                        <img class="jw-img" :src="firstLiveEvent.img_url" alt="EXPERTS" width="100%" :alt="firstLiveEvent.title" :title="firstLiveEvent.title" >
                                    </div>
                                    <div class="col-md-6">
                                        <div class="experts">
                                            <h2>{{firstLiveEvent.title}}</h2>
                                            <p>
                                                {{firstLiveEvent.longDescription}}
                                            </p>
                                            <br>
                                            <p class="date">
                                                LIVE&nbsp;{{getDateReference(firstLiveEvent.start_date, 'str')}}
                                            </p>
                                            <br>
                                            <div v-on:click="calendarLogging($event, firstLiveEvent.title)" v-if="!showJoin(firstLiveEvent.eventId)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                                Add to Calendar
                                                <span class="start">{{firstLiveEvent.start_date}}</span>
                                                <span class="end">{{firstLiveEvent.end_date}}</span>
                                                <span class="timezone">America/New_York</span>
                                                <span class="title">{{firstLiveEvent.title}}</span>
                                                <span class="description">{{firstLiveEvent.longDescription}}</span>
                                                <span class="location">{{buildEventLink (firstLiveEvent.eventId) }}</span>
                                            </div>
                                            <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(firstLiveEvent)" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                                <i class="fa fa-share-square-o"></i> Share
                                            </button>
                                            <div class="clearfix>"></div>
                                            <button  class="btn-pink" type="button" v-if="showJoin(firstLiveEvent.eventId)" @click="joinEvent(firstLiveEvent)" :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>
                                            <!--<button v-if="!isUserEntrolled(firstLiveEvent.eventId) && isEventToday(firstLiveEvent.start_date, firstLiveEvent.end_date) === false" @click="enrollUser(firstLiveEvent)" class="btn-pink">Reserve your spot</button>-->
                                            <!--<br>-->
                                            <!--<button class="btn btn-danger expert-section-btn btn-transparent btn-lg">Reserve a Seat at the Table</button>-->
                                        </div>
                                    </div>
                                </div>
                            </tab>
                            <tab header="TONE Talks" >
                                <div class="row" v-if="firstTalkEvent">
                                    <div class="col-md-6">
                                        <div class="experts">
                                            <img class="jw-img" :src="firstTalkEvent.img_url" alt="EXPERTS" width="100%" :alt="firstTalkEvent.title" :title="firstTalkEvent.title">
                                            <!--<h2>We all have something to contribute!</h2>-->
                                            <!--<p>-->
                                            <!--TONE Talks are moderated chats that let you give and get advice on the topics that matter to you from women like you!-->
                                            <!--</p>-->
                                            <!--<p>-->
                                            <!--Every Tuesday at 1pm ET-->
                                            <!--</p>-->
                                            <!--<br>-->
                                            <!--<br>-->
                                            <!--<button class="btn btn-danger expert-section-btn btn-transparent btn-lg">Reserve a Seat at the Table</button>-->
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="experts">
                                            <h2>{{firstTalkEvent.title}} </h2>
                                            <p>
                                                {{firstTalkEvent.longDescription}}
                                            </p>
                                            <br>
                                            <p class="date">
                                                {{getDateReference(firstTalkEvent.start_date, 'str')}}
                                            </p>
                                            <br>
                                            <div v-on:click="calendarLogging($event, firstTalkEvent.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(firstTalkEvent.eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                                Add to Calendar
                                                <span class="start">{{firstTalkEvent.start_date}}</span>
                                                <span class="end">{{firstTalkEvent.end_date}}</span>
                                                <span class="timezone">America/New_York</span>
                                                <span class="title">{{firstTalkEvent.title}}</span>
                                                <span class="description">{{firstTalkEvent.longDescription}}</span>
                                                <span class="location">{{buildEventLink (firstTalkEvent.eventId) }}</span>
                                            </div>
                                            <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(firstTalkEvent)" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                                <i class="fa fa-share-square-o"></i> Share
                                            </button>
                                            <div class="clearfix>"></div>
                                            <button class="btn-pink" type="button" v-if="showJoin(firstTalkEvent.eventId)" @click="joinEvent(firstTalkEvent)" :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>
                                            <!--<button class="btn-pink" v-if="!isUserEntrolled(firstTalkEvent.eventId) && isEventToday(firstTalkEvent.start_date, firstTalkEvent.end_date) === false" @click="enrollUser(firstTalkEvent)" type="button">Reserve your spot</button>-->
                                            <!--<br>-->
                                            <!--<button class="btn btn-danger expert-section-btn btn-transparent btn-lg">Reserve a Seat at the Table</button>-->
                                        </div>
                                    </div>
                                </div>
                            </tab>
                            <!--<tab v-bind:header="expert.name" >-->
                            <!--<div class="row">-->
                            <!--<div class="col-md-6">-->
                            <!--<img class="jw-img" v-bind:src="expert.small_image" alt="EXPERTS" width="100%" @click="redirectToExpert(expert.expertId)">-->
                            <!--</div>-->
                            <!--<div class="col-md-6">-->
                            <!--<div class="experts">-->
                            <!--<h2>-->
                            <!--Join an Exclusive Live <br>-->
                            <!--Chat With {{expert.name}}-->
                            <!--</h2>-->
                            <!--<br>-->
                            <!--<p>-->
                            <!--{{expert.biography}}-->
                            <!--</p>-->
                            <!--<br>-->
                            <!--<p class="date">-->
                            <!--Monday, June 23rd @9AM-->
                            <!--</p>-->
                            <!--<br>-->
                            <!--<button class="btn btn-danger expert-section-btn btn-transparent btn-lg">Reserve a Seat at the Table</button>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</tab>-->
                        </tabs>
                    </div>
                </div>
            </div>
        </div>
        <div class="random">
            <div class="container">
                <div class="margin-top-40">
                    <div class="blog-section clearfix">
                        <div class="row random-section-head">
                            <div class="col-md-4">
                                <h3 class="heading" v-bind:style="{ color: getCorpHeadingColor}">         <svg width="47px" height="48px" viewBox="0 0 47 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <title>Work</title>
                                    <desc>Created with Sketch.</desc>
                                    <defs></defs>
                                    <g id="Group-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="01_Tone_Home_Unauthenticated" transform="translate(-666.000000, -819.000000)">
                                            <g id="Group-7" transform="translate(88.000000, 800.000000)"></g>
                                            <g id="Work" transform="translate(666.000000, 819.000000)" :fill="getCorpHeaderColor">
                                                <path d="M45.6944444,-1.62630326e-19 C34.1361,-1.62630326e-19 23.4467333,5.0007033 15.9565,13.1868132 L1.30555556,13.1868132 C0.777223333,13.1868132 0.301896667,13.5082444 0.0999533333,14.0007033 C-0.102000444,14.4931464 0.0101937778,15.0597626 0.383504333,15.4368527 L8.84924878,23.9877099 C7.97410878,25.934822 7.23772322,27.964378 6.66651656,30.0742154 C6.54208144,30.5316343 6.67059511,31.0199736 7.00310444,31.3537582 L15.9566044,40.3988571 C16.2054747,40.6502295 16.5379944,40.78416 16.8806767,40.78416 C16.9949128,40.78416 17.1111908,40.7697389 17.2254269,40.7367719 C19.3143158,40.1598224 21.3257069,39.4160334 23.2513491,38.5320949 L31.7170936,47.082951 C31.9659638,47.3384482 32.3005202,47.4723735 32.6391291,47.4723735 C32.8064021,47.4723735 32.9777589,47.4394064 33.1389114,47.3714099 C33.6264529,47.1674258 33.9447003,46.6873308 33.9447003,46.1536869 L33.9447003,31.3554462 C42.0495892,23.7893802 47.0002559,12.9930725 47.0002559,1.31852308 C47.0002559,0.589134066 46.4168292,-0.000158241758 45.6947003,-0.000158241758 L45.6944444,-1.62630326e-19 Z M17.2599667,37.9864615 L9.39216667,30.0395604 C12.5765211,19.1398681 20.3483889,10.4882637 30.2074222,6.00474725 L41.0576333,16.9619341 C36.6167078,26.9200879 28.0532556,34.7725714 17.2599667,37.9864615 Z M44.3664333,2.66004396 C44.2256788,6.70881758 43.4484711,10.6275165 42.12657,14.3098022 L32.8325811,4.92448352 C36.4759167,3.58934505 40.3578033,2.80225055 44.3663811,2.66004396 L44.3664333,2.66004396 Z M4.45716667,15.8241758 L13.7407111,15.8241758 C12.3719144,17.5982242 11.1438567,19.4958593 10.0749722,21.4987253 L4.45716667,15.8241758 Z M31.3333333,42.9705495 L25.7152667,37.296 C27.6980922,36.2142593 29.5748022,34.9739077 31.3333333,33.5934066 L31.3333333,42.9705495 Z" id="Fill-1"></path>
                                                <path d="M1.30555556,47.4725275 C1.64010156,47.4725275 1.97462667,47.3447789 2.22962778,47.0872246 L7.45185,41.8124993 C7.96183133,41.2973908 7.96183133,40.4629081 7.45185,39.9477785 C6.94186867,39.4326699 6.11569222,39.4326699 5.60569,39.9477785 L0.383467778,45.2225037 C-0.126513556,45.7376123 -0.126513556,46.5720949 0.383467778,47.0872246 C0.636421778,47.3447789 0.970967778,47.4725275 1.30550333,47.4725275 L1.30555556,47.4725275 Z" id="Fill-2"></path>
                                                <path d="M6.909,47.0874709 C7.16399067,47.3450252 7.49853667,47.4727738 7.83307222,47.4727738 C8.16760778,47.4727738 8.50214333,47.3450252 8.75714444,47.0874709 L12.6738111,43.1314286 C13.1837924,42.61632 13.1837924,41.7818374 12.6738111,41.2667077 C12.1638298,40.7515991 11.3376533,40.7515991 10.8276511,41.2667077 L6.91098444,45.2227501 C6.40100311,45.7358015 6.40100311,46.5723407 6.90894256,47.0874709 L6.909,47.0874709 Z" id="Fill-3"></path>
                                                <path d="M1.30555556,40.8791209 C1.64010156,40.8791209 1.97462667,40.7513723 2.22962778,40.493818 L6.14629444,36.5377741 C6.65627578,36.0226655 6.65627578,35.1881829 6.14629444,34.6730532 C5.63631311,34.1579446 4.81013667,34.1579446 4.30013444,34.6730532 L0.383467778,38.6290971 C-0.126513556,39.1442057 -0.126513556,39.9786884 0.383467778,40.493818 C0.636421778,40.7513723 0.970967778,40.8791209 1.30550333,40.8791209 L1.30555556,40.8791209 Z" id="Fill-4"></path>
                                                <path d="M26.1111111,14.5054945 C22.51065,14.5054945 19.5833333,17.4622418 19.5833333,21.0989011 C19.5833333,24.7355604 22.51065,27.6923077 26.1111111,27.6923077 C29.7115722,27.6923077 32.6388889,24.7355604 32.6388889,21.0989011 C32.6388889,17.4622418 29.7115722,14.5054945 26.1111111,14.5054945 Z M26.1111111,25.0549451 C23.9508344,25.0549451 22.1944444,23.2808967 22.1944444,21.0989011 C22.1944444,18.9169055 23.9508344,17.1428571 26.1111111,17.1428571 C28.2713878,17.1428571 30.0277778,18.9169055 30.0277778,21.0989011 C30.0277778,23.2808967 28.2713878,25.0549451 26.1111111,25.0549451 Z" id="Fill-5"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>

<!--                                    <i class="nav-icon career-pink-icon" v-bind:style="{ color: getCorpHeadingColor + ' !important'}"></i>-->
                                    <br/>WORK<br/>
                                </h3>
                                <div class="panel panel-default">
                                    <div class="panel-body no-padding" v-if = "getAuthWorkVideos">
                                        <a :href="'/watch/' + getAuthWorkVideos[0].mediaid + '/' + getAuthWorkVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                            <div class="image-container">
                                                <img class="jw-img-1" :src="getAuthWorkVideos[0].image"  :alt="getAuthWorkVideos[0].title" :title="getAuthWorkVideos[0].title" />
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(getAuthWorkVideos[0].duration) }}</p>
                                            </div>
                                        </a>
                                        <div class="col-md-12 margin-top-20 margin-bottom-40">
                                            <h4 class="cursor" @click="setVideoPlayerObject(getAuthWorkVideos[0].mediaid, getAuthWorkVideos[0].title)"><i class="fa fa-play-circle-o"></i> {{getAuthWorkVideos[0].title}}</h4>
                                            <hr>
                                            <div class="plusicon btn-group">
                                                <button title="Add to Playlist" id="workVideo1" type="button" @click="showPlaylistMenu('workVideo1')" class="dropdown-toggle ellipsis pull-right">
<!--                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                                </button>
                                                <ul class="hide">
                                                    <li  v-if="getUserPlaylists">
                                                        <label>
                                                            <b> Add to ...</b>
                                                        </label>
                                                    </li>
                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                        <label class="notificationwithcheckboxes">
                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getAuthWorkVideos[0])" @click="setPlaylistVideoStatus(getAuthWorkVideos[0], playlist, verifyVideoExists(playlist, getAuthWorkVideos[0])) "/> {{playlist.title}}
                                                            <transition name="fade" v-if="getAuthWorkVideos[0].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">
                                                                <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                                <span class="added">Added</span>
                                                            </transition>
                                                            <transition name="fade" v-if="getAuthWorkVideos[0].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">
                                                                <span class="removed">Removed</span>
                                                            </transition>
                                                        </label>
                                                    </li>
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                    <li><label style="color:#f0617d">Create new playlist</label></li>
                                                    <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                        <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                    </label> </li>
                                                </ul>
                                                <div class="backdropformenu"  @click="hidePlaylistMenu('workVideo1')"></div>
                                            </div>
                                            <p class="right-heart-icon">
                                                <a href="javascript:" @click="setVideoStatus(getAuthWorkVideos[0])" title ="Liked this video?">
                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                       v-bind:class="{'activeIcons': getVideoStatus(getAuthWorkVideos[0])}" aria-hidden="true" ></i></a>
                                            </p>
                                            <!--<div v-if="getVideoStatus(getAuthWorkVideos[0])">-->
                                            <!--<i class="fa fa-heart fa-2x"  aria-hidden="true"></i>-->
                                            <!--</div>-->
                                            <!--<div v-else>-->
                                            <!--<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>-->
                                            <!--</div>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-body no-padding" v-if = "getAuthWorkVideos">
                                        <a :href="'/watch/' + getAuthWorkVideos[1].mediaid + '/' + getAuthWorkVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                            <div class="image-container">
                                                <img class="jw-img-1" :src="getAuthWorkVideos[1].image" :alt="getAuthWorkVideos[1].title" :title="getAuthWorkVideos[1].title"/>
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(getAuthWorkVideos[1].duration) }}</p>
                                            </div>
                                        </a>
                                        <div class="col-md-12 margin-top-20 margin-bottom-40">
                                            <h4 class="cursor" @click="setVideoPlayerObject(getAuthWorkVideos[1].mediaid, getAuthWorkVideos[1].title)"><i class="fa fa-play-circle-o"></i> {{getAuthWorkVideos[1].title}}</h4>
                                            <hr>
                                            <div class="plusicon btn-group">
                                                <button title="Add to Playlist" id="workVideo2" type="button" @click="showPlaylistMenu('workVideo2')" class="dropdown-toggle ellipsis pull-right">
<!--                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                                </button>
                                                <ul class="hide">
                                                    <li  v-if="getUserPlaylists">
                                                        <label>
                                                            <b> Add to ...</b>
                                                        </label>
                                                    </li>
                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                        <label class="notificationwithcheckboxes">
                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getAuthWorkVideos[1])" @click="setPlaylistVideoStatus(getAuthWorkVideos[1], playlist, verifyVideoExists(playlist, getAuthWorkVideos[1])) "/> {{playlist.title}}
                                                            <transition name="fade" v-if="getAuthWorkVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">
                                                                <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                                <span class="added">Added</span>
                                                            </transition>
                                                            <transition name="fade" v-if="getAuthWorkVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">
                                                                <span class="removed">Removed</span>
                                                            </transition>
                                                        </label>
                                                    </li>
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                    <li><label style="color:#f0617d">Create new playlist</label></li>
                                                    <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                        <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                    </label> </li>
                                                </ul>
                                                <div class="backdropformenu"  @click="hidePlaylistMenu('workVideo2')"></div>
                                            </div>
                                            <p class="right-heart-icon">
                                                <a href="javascript:" @click="setVideoStatus(getAuthWorkVideos[1])" title ="Liked this video?">
                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                       v-bind:class="{'activeIcons': getVideoStatus(getAuthWorkVideos[1])}" aria-hidden="true" ></i></a>
                                            </p>
                                            <!--<div v-if="getVideoStatus(getAuthWorkVideos[1])">-->
                                            <!--<i class="fa fa-heart fa-2x"  aria-hidden="true"></i>-->
                                            <!--</div>-->
                                            <!--<div v-else>-->
                                            <!--<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>-->
                                            <!--</div>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-body no-padding">
                                        <div class="col-md-12 margin-top-20 margin-bottom-40 watch-all">
                                            <router-link  :to="{ path: '/work'}">
                                                See &nbsp;All &nbsp;Work &nbsp;<span class="fa fa-angle-double-right fa-2x" aria-hidden="true"></span>
                                            </router-link>
                                            <!--<a href="#/work">See &nbsp;All &nbsp;Work &nbsp;</a><span class="fa fa-angle-double-right fa-2x" aria-hidden="true"></span>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" >
                                <h3 class="heading" v-bind:style="{ color: getCorpHeadingColor}">
                                    <svg width="34px" height="47px" viewBox="0 0 34 47" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <!-- Generator: Sketch 44.1 (41455) - http://www.bohemiancoding.com/sketch -->
                                        <title>Page 1</title>
                                        <desc>Created with Sketch.</desc>
                                        <defs></defs>
                                        <g id="Group-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <g id="01_Tone_Home_Unauthenticated" transform="translate(-125.000000, -1270.000000)" :fill="getCorpHeaderColor">
                                                <path d="M131.268161,1315.78641 C130.977535,1315.78641 130.686929,1315.70766 130.426289,1315.54453 C129.798161,1315.15078 129.528161,1314.37453 129.775649,1313.67517 L136.398209,1294.97773 L127.583969,1294.97586 C127.028993,1294.97586 126.513329,1294.68524 126.226481,1294.20709 C125.939604,1293.73084 125.924604,1293.1402 126.18523,1292.64896 L137.24011,1271.84 C137.515735,1271.32251 138.051982,1271 138.638878,1271 L153.378238,1271 C153.97075,1271 154.512622,1271.33 154.786366,1271.85498 C155.058242,1272.38187 155.015114,1273.01374 154.671991,1273.49749 L145.384951,1286.60725 L157.062391,1286.60725 C157.701751,1286.60725 158.277367,1286.99162 158.524903,1287.58035 C158.770529,1288.17099 158.637406,1288.85158 158.187406,1289.30538 L132.393166,1315.31898 C132.08754,1315.62648 131.678782,1315.78585 131.268142,1315.78585 L131.268161,1315.78641 Z M130.218161,1291.80897 L138.638801,1291.80897 C139.152545,1291.80897 139.634417,1292.05834 139.932545,1292.47833 C140.228796,1292.89833 140.303796,1293.43646 140.131294,1293.9202 L135.121054,1308.0706 L153.261694,1289.77444 L142.322974,1289.77444 C141.730462,1289.77444 141.18859,1289.44444 140.916718,1288.91755 C140.644841,1288.39252 140.687969,1287.75878 141.031092,1287.27503 L150.316212,1274.16527 L139.591092,1274.16527 L130.218161,1291.80897 Z" id="Page-1" stroke="#FFFFFF" stroke-width="0.5"></path>
                                                <g id="Group-7-Copy" transform="translate(126.000000, 1315.000000)" font-size="30" font-family="Quicksand-Regular, Quicksand" line-spacing="60" font-weight="normal">
                                                    <text id="Inspiration">
                                                        <tspan x="0" y="28">Inspiration</tspan>
                                                    </text>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
<!--                                    <i class="nav-icon inspiration-pink-icon" v-bind:style="{ color: getCorpHeadingColor}"></i>-->
                                    <br/>LIFE<br/>
                                </h3>
                                <div class="panel panel-default">
                                    <div class="panel-body no-padding" v-if = "getAuthLifeVideos">
                                        <a :href="'/watch/' + getAuthLifeVideos[0].mediaid + '/' + getAuthLifeVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                            <div class="image-container">
                                                <img class="jw-img-1" :src="getAuthLifeVideos[0].image"  :alt="getAuthLifeVideos[0].title" :title="getAuthLifeVideos[0].title" />
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(getAuthLifeVideos[0].duration) }}</p>
                                            </div>
                                        </a>
                                        <div class="col-md-12 margin-top-20 margin-bottom-40">
                                            <h4 class="cursor" @click="setVideoPlayerObject(getAuthLifeVideos[0].mediaid, getAuthLifeVideos[0].title)"><i class="fa fa-play-circle-o"></i> {{getAuthLifeVideos[0].title}}</h4>
                                            <hr>
                                            <div class="plusicon btn-group">
                                                <button title="Add to Playlist" id="lifeVideo1" type="button" @click="showPlaylistMenu('lifeVideo1')" class="dropdown-toggle ellipsis pull-right">
<!--                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                                </button>
                                                <ul class="hide">
                                                    <li  v-if="getUserPlaylists">
                                                        <label>
                                                            <b> Add to ...</b>
                                                        </label>
                                                    </li>
                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                        <label class="notificationwithcheckboxes">
                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getAuthLifeVideos[0])" @click="setPlaylistVideoStatus(getAuthLifeVideos[0], playlist, verifyVideoExists(playlist, getAuthLifeVideos[0])) "/> {{playlist.title}}
                                                            <transition name="fade" v-if="getAuthLifeVideos[0].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">
                                                                <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                                <span class="added">Added</span>
                                                            </transition>
                                                            <transition name="fade" v-if="getAuthLifeVideos[0].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">
                                                                <span class="removed">Removed</span>
                                                            </transition>
                                                        </label>
                                                    </li>
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                    <li><label style="color:#f0617d">Create new playlist</label></li>
                                                    <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                        <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                    </label> </li>
                                                </ul>
                                                <div class="backdropformenu"  @click="hidePlaylistMenu('lifeVideo1')"></div>
                                            </div>
                                            <p class="right-heart-icon">
                                                <a href="javascript:" @click="setVideoStatus(getAuthLifeVideos[0])" title ="Liked this video?">
                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                       v-bind:class="{'activeIcons': getVideoStatus(getAuthLifeVideos[0])}" aria-hidden="true" ></i></a>
                                            </p>
                                            <!--<div v-if="getVideoStatus(getAuthLifeVideos[0])">-->
                                            <!--<i class="fa fa-heart fa-2x" aria-hidden="true"></i>-->
                                            <!--</div>-->
                                            <!--<div v-else>-->
                                            <!--<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>-->
                                            <!--</div>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-body no-padding" v-if = "getAuthLifeVideos">
                                        <a :href="'/watch/' + getAuthLifeVideos[1].mediaid + '/' + getAuthLifeVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                            <div class="image-container">
                                                <img class="jw-img-1" :src="getAuthLifeVideos[1].image"  :alt="getAuthLifeVideos[1].title" :title="getAuthLifeVideos[1].title" />
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(getAuthLifeVideos[1].duration) }}</p>
                                            </div>
                                        </a>
                                        <div class="col-md-12 margin-top-20 margin-bottom-40">
                                            <h4 class="cursor" @click="setVideoPlayerObject(getAuthLifeVideos[1].mediaid, getAuthLifeVideos[1].title)"><i class="fa fa-play-circle-o"></i> {{getAuthLifeVideos[1].title}}</h4>
                                            <hr>
                                            <div class="plusicon btn-group">
                                                <button title="Add to Playlist" id="lifeVideo2" type="button" @click="showPlaylistMenu('lifeVideo2')" class="dropdown-toggle ellipsis pull-right">
<!--                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                                </button>
                                                <ul class="hide">
                                                    <li  v-if="getUserPlaylists">
                                                        <label>
                                                            <b> Add to ...</b>
                                                        </label>
                                                    </li>
                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                        <label class="notificationwithcheckboxes">
                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getAuthLifeVideos[1])" @click="setPlaylistVideoStatus(getAuthLifeVideos[1], playlist, verifyVideoExists(playlist, getAuthLifeVideos[1])) "/> {{playlist.title}}
                                                            <transition name="fade" v-if="getAuthLifeVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">
                                                                <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                                <span class="added">Added</span>
                                                            </transition>
                                                            <transition name="fade"  v-if="getAuthLifeVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">
                                                                <span class="removed">Removed</span>
                                                            </transition>
                                                        </label>
                                                    </li>
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                    <li><label style="color:#f0617d">Create new playlist</label></li>
                                                    <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                        <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                    </label> </li>
                                                </ul>
                                                <div class="backdropformenu"  @click="hidePlaylistMenu('lifeVideo2')"></div>
                                            </div>
                                            <p class="right-heart-icon">
                                                <a href="javascript:" @click="setVideoStatus(getAuthLifeVideos[1])" title ="Liked this video?">
                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                       v-bind:class="{'activeIcons': getVideoStatus(getAuthLifeVideos[1])}" aria-hidden="true" ></i></a>
                                            </p>
                                            <!--<div v-if="getVideoStatus(getAuthLifeVideos[1])">-->
                                            <!--<i class="fa fa-heart fa-2x" aria-hidden="true"></i>-->
                                            <!--</div>-->
                                            <!--<div v-else>-->
                                            <!--<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>-->
                                            <!--</div>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-body no-padding">
                                        <div class="col-md-12 margin-top-20 margin-bottom-40 watch-all">
                                            <router-link  :to="{ path: '/life'}">
                                                See &nbsp;All &nbsp;Life &nbsp;<span class="fa fa-angle-double-right fa-2x" aria-hidden="true"></span>
                                            </router-link>
                                            <!--<a href="#/life">See &nbsp;All &nbsp;Life &nbsp;</a><span class="fa fa-angle-double-right" aria-hidden="true"></span>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <h3 class="heading" v-bind:style="{ color: getCorpHeadingColor}">
                                    <svg width="59px" height="49px" viewBox="0 0 59 49" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <!-- Generator: Sketch 44.1 (41455) - http://www.bohemiancoding.com/sketch -->
                                        <title>Page 1</title>
                                        <desc>Created with Sketch.</desc>
                                        <defs></defs>
                                        <g id="Group-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <g id="01_Tone_Home_Unauthenticated" transform="translate(-665.000000, -1737.000000)">
                                                <g id="Group-7-Copy-2" transform="translate(88.000000, 1726.000000)"></g>
                                                <path d="M720.393793,1779.55672 L720.248873,1779.68175 C715.432452,1783.90429 709.738162,1785.73139 704.609017,1784.72833 C699.982965,1783.81053 696.672699,1780.75588 693.478531,1777.80351 C690.014703,1774.60396 686.749756,1771.58336 681.933407,1771.06622 C677.116986,1770.54906 671.859885,1772.76828 667.705503,1777.21247 C669.319536,1779.4601 677.002852,1788.69794 689.528558,1781.06846 C689.863862,1780.92922 690.250312,1781.05993 690.432178,1781.3725 C690.616881,1781.68791 690.540158,1782.08858 690.256,1782.31308 C686.488104,1784.60333 683.098184,1785.47 680.137377,1785.47 C671.226296,1785.47 666.177169,1777.64134 666.111699,1777.53368 C665.938366,1777.25805 665.969624,1776.90286 666.185578,1776.66134 C670.717863,1771.5693 676.494789,1769.01454 682.035663,1769.61148 C687.332264,1770.17979 690.932195,1773.51009 694.402061,1776.72667 C697.587427,1779.63641 700.599445,1782.45806 704.824752,1783.27358 C709.510453,1784.20557 714.752788,1782.48934 719.214148,1778.55944 L719.387481,1778.41452 L719.390325,1778.41452 C719.95579,1777.95987 720.4985,1777.47395 721.012869,1776.95965 C718.830564,1771.81079 712.885963,1770.61729 711.700971,1770.41273 C709.538525,1771.73688 707.199966,1772.74845 704.753384,1773.41624 C704.688023,1773.42477 704.622671,1773.42477 704.557318,1773.41624 C704.364097,1773.44182 704.168024,1773.39067 704.014586,1773.27132 C703.858304,1773.15481 703.756004,1772.97864 703.730428,1772.78542 C703.676438,1772.38476 703.957751,1772.01535 704.361252,1771.96138 C711.774544,1769.85298 716.363933,1765.82932 718.023212,1760.01544 L718.020368,1760.01544 C718.710864,1757.52906 718.84157,1754.92055 718.406818,1752.37737 C708.347844,1751.34303 704.105442,1757.36146 703.479848,1758.34175 C702.920065,1762.26874 701.13838,1766.18423 698.154804,1770.03746 L698.154804,1770.0403 C697.901904,1770.33014 697.467153,1770.37276 697.163092,1770.13691 C696.859031,1769.90106 696.790849,1769.47199 697.00681,1769.15371 C699.916551,1765.55349 701.610092,1761.82844 702.113041,1758.08869 C702.323314,1756.53155 702.323314,1754.95447 702.113041,1753.39732 C701.152608,1746.12297 695.821891,1741.03092 694.213823,1739.64152 C685.803217,1747.42435 687.308862,1755.83277 689.090497,1760.34505 C689.749735,1761.44472 690.332228,1762.58984 690.838014,1763.76909 C691.036924,1764.1186 690.917581,1764.56476 690.56807,1764.76648 C690.218559,1764.96822 689.772402,1764.84604 689.570684,1764.49653 C688.925652,1763.47361 688.377254,1762.38813 687.933955,1761.26003 C685.314024,1756.82151 681.773452,1754.05958 677.371596,1753.03346 C675.11822,1752.51062 672.779661,1752.47652 670.5121,1752.93969 C668.409376,1759.30475 672.810941,1765.04494 672.853569,1765.10168 C673.10078,1765.41993 673.043953,1765.87741 672.728537,1766.1246 C672.410284,1766.36897 671.9528,1766.31214 671.705618,1765.99673 C671.495345,1765.72678 666.613571,1759.34753 669.267546,1752.0678 L669.267546,1752.06496 C669.34995,1751.84899 669.526127,1751.68703 669.74777,1751.62167 C672.799578,1750.91981 675.984944,1751.05621 678.968738,1752.01665 C681.949549,1752.97708 684.614872,1754.72751 686.683188,1757.07741 C685.680128,1751.88309 686.291057,1744.71102 693.718868,1738.1641 L693.716024,1738.1641 C693.985968,1737.9453 694.372418,1737.9453 694.64234,1738.1641 C694.969118,1738.36016 702.337149,1744.07167 703.573062,1753.22128 C703.689568,1754.11355 703.743558,1755.00859 703.735032,1755.90653 C705.968477,1753.55655 710.776387,1750.08705 719.16466,1751.11288 L719.161823,1751.11288 C719.457344,1751.14982 719.698874,1751.36294 719.772752,1751.64993 C719.772752,1751.78064 722.384099,1762.39415 713.416205,1769.32733 C715.976414,1769.98089 720.690557,1771.8364 722.565885,1776.8061 C722.79889,1777.38009 722.429491,1777.84611 720.392091,1779.55667 L720.393793,1779.55672 Z" id="Page-1" :stroke="getCorpHeaderColor" :fill="getCorpHeaderColor"></path>
                                            </g>
                                        </g>
                                    </svg>
<!--                                    <i class="nav-icon mind-body-pink-icon"></i>-->
                                    <br/>MIND BODY<br/>
                                </h3>
                                <div class="panel panel-default">
                                    <div class="panel-body no-padding" v-if = "getAuthMindbodyVideos">
                                        <a :href="'/watch/' + getAuthMindbodyVideos[0].mediaid + '/' + getAuthMindbodyVideos[0].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                            <div class="image-container">
                                                <img class="jw-img-1" :src="getAuthMindbodyVideos[0].image"  :alt="getAuthMindbodyVideos[0].title" :title="getAuthMindbodyVideos[0].title" />
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(getAuthMindbodyVideos[0].duration) }}</p>
                                            </div>
                                        </a>
                                        <div class="col-md-12 margin-top-20 margin-bottom-40">
                                            <h4 class="cursor" @click="setVideoPlayerObject(getAuthMindbodyVideos[0].mediaid, getAuthMindbodyVideos[0].title)"><i class="fa fa-play-circle-o"></i> {{getAuthMindbodyVideos[0].title}}</h4>
                                            <hr>
                                            <div class="plusicon btn-group">
                                                <button title="Add to Playlist" id="mindbodyVideo1" type="button" @click="showPlaylistMenu('mindbodyVideo1')" class="dropdown-toggle ellipsis pull-right">
<!--                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                                </button>
                                                <ul class="hide">
                                                    <li  v-if="getUserPlaylists">
                                                        <label>
                                                            <b> Add to ...</b>
                                                        </label>
                                                    </li>
                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                        <label class="notificationwithcheckboxes">
                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getAuthMindbodyVideos[0])" @click="setPlaylistVideoStatus(getAuthMindbodyVideos[0], playlist, verifyVideoExists(playlist, getAuthMindbodyVideos[0])) "/> {{playlist.title}}
                                                            <transition name="fade" v-if="getAuthMindbodyVideos[0].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">
                                                                <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                                <span class="added">Added</span>
                                                            </transition>
                                                            <transition name="fade" v-if="getAuthMindbodyVideos[0].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">
                                                                <span class="removed">Removed</span>
                                                            </transition>
                                                        </label>
                                                    </li>
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                    <li><label style="color:#f0617d">Create new playlist</label></li>
                                                    <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                        <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                    </label> </li>
                                                </ul>
                                                <div class="backdropformenu"  @click="hidePlaylistMenu('mindbodyVideo1')"></div>
                                            </div>
                                            <p class="right-heart-icon">
                                                <a href="javascript:" @click="setVideoStatus(getAuthMindbodyVideos[0])" title ="Liked this video?">
                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                       v-bind:class="{'activeIcons': getVideoStatus(getAuthMindbodyVideos[0])}" aria-hidden="true" ></i></a>
                                            </p>
                                            <!--<div v-if="getVideoStatus(getAuthMindbodyVideos[0])">-->
                                            <!--<i class="fa fa-heart fa-2x" aria-hidden="true"></i>-->
                                            <!--</div>-->
                                            <!--<div v-else>-->
                                            <!--<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>-->
                                            <!--</div>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-body no-padding" v-if = "getAuthMindbodyVideos">
                                        <a :href="'/watch/' + getAuthMindbodyVideos[1].mediaid + '/' + getAuthMindbodyVideos[1].title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase() " class="nounderline">
                                            <div class="image-container">
                                                <img class="jw-img-1" :src="getAuthMindbodyVideos[1].image"  :alt="getAuthMindbodyVideos[1].title" :title="getAuthMindbodyVideos[1].title" />
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(getAuthMindbodyVideos[1].duration) }}</p>
                                            </div></a>
                                        <div class="col-md-12 margin-top-20 margin-bottom-40">
                                            <h4 class="cursor" @click="setVideoPlayerObject(getAuthMindbodyVideos[1].mediaid, getAuthMindbodyVideos[1].title)"><i class="fa fa-play-circle-o"></i> {{getAuthMindbodyVideos[1].title}}</h4>
                                            <hr>
                                            <div class="plusicon btn-group">
                                                <button title="Add to Playlist" id="mindbodyVideo2" type="button" @click="showPlaylistMenu('mindbodyVideo2')" class="dropdown-toggle ellipsis pull-right">
<!--                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                                </button>
                                                <ul class="hide">
                                                    <li  v-if="getUserPlaylists">
                                                        <label>
                                                            <b> Add to ...</b>
                                                        </label>
                                                    </li>
                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                        <label class="notificationwithcheckboxes">
                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getAuthMindbodyVideos[1])" @click="setPlaylistVideoStatus(getAuthMindbodyVideos[1], playlist, verifyVideoExists(playlist, getAuthMindbodyVideos[1])) "/> {{playlist.title}}
                                                            <transition name="fade" v-if="getAuthMindbodyVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">
                                                                <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                                <span class="added">Added</span>
                                                            </transition>
                                                            <transition name="fade" v-if="getAuthMindbodyVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">
                                                                <span class="removed">Removed</span>
                                                            </transition>
                                                        </label>
                                                    </li>
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Second option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Third option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <!--<li>-->
                                                    <!--<label>-->
                                                    <!--<input type="checkbox" /> Forth option-->
                                                    <!--</label>-->
                                                    <!--</li>-->
                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                    <li><label style="color:#f0617d">Create new playlist</label></li>
                                                    <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                        <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                    </label> </li>
                                                </ul>
                                                <div class="backdropformenu"  @click="hidePlaylistMenu('mindbodyVideo2')"></div>
                                            </div>
                                            <p class="right-heart-icon">
                                                <a href="javascript:" @click="setVideoStatus(getAuthMindbodyVideos[1])" title ="Liked this video?">
                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                       v-bind:class="{'activeIcons': getVideoStatus(getAuthMindbodyVideos[1])}" aria-hidden="true" ></i></a>
                                            </p>
                                            <!--<div v-if="getVideoStatus(getAuthMindbodyVideos[1])">-->
                                            <!--<i class="fa fa-heart fa-2x" aria-hidden="true"></i>-->
                                            <!--</div>-->
                                            <!--<div v-else>-->
                                            <!--<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>-->
                                            <!--</div>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-body no-padding">
                                        <div class="col-md-12 margin-top-20 margin-bottom-40 watch-all">
                                            <router-link  :to="{ path: '/mindbody'}">
                                                See &nbsp;All &nbsp;Mind Body &nbsp;<span class="fa fa-angle-double-right fa-2x" aria-hidden="true"></span>
                                            </router-link>
                                            <!--<a href="#/mindbody">See &nbsp;All &nbsp;Mind Body &nbsp;</a><span class="fa fa-angle-double-right" aria-hidden="true"></span>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="col-md-4 side-border-right" v-if="!toggleBottonSection(4)" v-bind:class="{ 'side-border-left': !toggleBottonSection(4)}">-->
<!--                                <h3 class="heading" v-bind:style="{ color: getCorpHeadingColor}">-->
<!--                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"-->
<!--                                         width="29px" height="16px" viewBox="0 0 29 16" enable-background="new 0 0 29 16" xml:space="preserve">-->
<!--<title>Money</title>-->
<!--                                        <desc>Created with Sketch.</desc>-->
<!--                                        <g id="Nav" transform="translate(246.000000, 24.000000)">-->
<!--	<g id="Money" transform="translate(403.000000, 6.000000)">-->
<!--		<polyline id="Stroke-2" fill="none" :stroke="getCorpHeaderColor" points="-647.752,-14.736 -643.234,-19.268 -641.104,-17.098-->
<!--			-636.199,-21.95 -631.875,-17.672 -620.646,-28.716 		"/>-->
<!--        <polyline id="Stroke-3" fill="none" :stroke="getCorpHeaderColor" points="-624.969,-28.715 -620.645,-28.715 -620.645,-24.438 		"/>-->
<!--	</g>-->
<!--</g>-->
<!--</svg>-->
<!--&lt;!&ndash;                                    <i class="nav-icon money-pink-icon"></i>&ndash;&gt;-->
<!--                                    <br/>MONEY<br/>-->
<!--                                </h3>-->
<!--                                <div class="panel panel-default">-->
<!--                                    <div class="panel-body no-padding" v-if = "getAuthMoneyVideos">-->
<!--                                        <a :href="'/watch/' + getAuthMoneyVideos[0].mediaid" class="nounderline">-->
<!--                                            <img class="jw-img" :src="getAuthMoneyVideos[0].image"  :alt="getAuthMoneyVideos[0].title" :title="getAuthMoneyVideos[0].title" />-->
<!--                                        </a>-->
<!--                                        <div class="col-md-12 margin-top-20 margin-bottom-40">-->
<!--                                            <h4 class="cursor" @click="setVideoPlayerObject(getAuthMoneyVideos[0].mediaid)">{{getAuthMoneyVideos[0].title}}</h4>-->
<!--                                            <hr>-->
<!--                                            <div class="plusicon btn-group">-->
<!--                                                <button title="Add to Playlist" id="moneyVideo1" type="button" @click="showPlaylistMenu('moneyVideo1')" class="dropdown-toggle ellipsis pull-right">-->
<!--&lt;!&ndash;                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>&ndash;&gt;-->
<!--                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"-->
<!--                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">-->
<!--<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>-->
<!--                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>-->
<!--                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>-->
<!--                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>-->
<!--                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>-->
<!--</svg>-->
<!--                                                </button>-->
<!--                                                <ul class="hide">-->
<!--                                                    <li  v-if="getUserPlaylists">-->
<!--                                                        <label>-->
<!--                                                            <b> Add to ...</b>-->
<!--                                                        </label>-->
<!--                                                    </li>-->
<!--                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>-->
<!--                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">-->
<!--                                                        <label class="notificationwithcheckboxes">-->
<!--                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getAuthMoneyVideos[0])" @click="setPlaylistVideoStatus(getAuthMoneyVideos[0], playlist, verifyVideoExists(playlist, getAuthMoneyVideos[0])) "/> {{playlist.title}}-->
<!--                                                            <transition name="fade">-->
<!--                                                                &lt;!&ndash;<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>&ndash;&gt;-->
<!--                                                                <span class="added" v-if="getAuthMoneyVideos[0].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>-->
<!--                                                            </transition>-->
<!--                                                            <transition name="fade">-->
<!--                                                                <span class="removed" v-if="getAuthMoneyVideos[0].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>-->
<!--                                                            </transition>-->
<!--                                                        </label>-->
<!--                                                    </li>-->
<!--                                                    &lt;!&ndash;<li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<input type="checkbox" /> Second option&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<input type="checkbox" /> Third option&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<input type="checkbox" /> Forth option&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</li>&ndash;&gt;-->
<!--                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>-->
<!--                                                    <li><label style="color:#f0617d">Create new playlist</label></li>-->
<!--                                                    <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />-->
<!--                                                        <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>-->

<!--                                                    </label> </li>-->
<!--                                                </ul>-->
<!--                                                <div class="backdropformenu"  @click="hidePlaylistMenu('moneyVideo1')"></div>-->
<!--                                            </div>-->
<!--                                            <p class="right-heart-icon">-->
<!--                                                <a href="javascript:" @click="setVideoStatus(getAuthMoneyVideos[0])" title ="Liked this video?">-->
<!--                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"-->
<!--                                                       v-bind:class="{'activeIcons': getVideoStatus(getAuthMoneyVideos[0])}" aria-hidden="true" ></i></a>-->
<!--                                            </p>-->
<!--                                            &lt;!&ndash;<div v-if="getVideoStatus(getAuthMoneyVideos[0])">&ndash;&gt;-->
<!--                                            &lt;!&ndash;<i class="fa fa-heart fa-2x" aria-hidden="true"></i>&ndash;&gt;-->
<!--                                            &lt;!&ndash;</div>&ndash;&gt;-->
<!--                                            &lt;!&ndash;<div v-else>&ndash;&gt;-->
<!--                                            &lt;!&ndash;<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>&ndash;&gt;-->
<!--                                            &lt;!&ndash;</div>&ndash;&gt;-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="panel panel-default">-->
<!--                                    <div class="panel-body no-padding" v-if = "getAuthMoneyVideos">-->
<!--                                        <a :href="'/watch/' + getAuthMoneyVideos[1].mediaid" class="nounderline">-->
<!--                                            <img class="jw-img" :src="getAuthMoneyVideos[1].image" :alt="getAuthMoneyVideos[1].title" :title="getAuthMoneyVideos[1].title" />-->
<!--                                        </a>-->
<!--                                        <div class="col-md-12 margin-top-20 margin-bottom-40">-->
<!--                                            <h4 class="cursor" @click="setVideoPlayerObject(getAuthMoneyVideos[1].mediaid)">{{getAuthMoneyVideos[1].title}}</h4>-->
<!--                                            <hr>-->
<!--                                            <div class="plusicon btn-group">-->
<!--                                                <button title="Add to Playlist" id="moneyVideo2" type="button" @click="showPlaylistMenu('moneyVideo2')" class="dropdown-toggle ellipsis pull-right">-->
<!--&lt;!&ndash;                                                    <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>&ndash;&gt;-->
<!--                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"-->
<!--                                                         width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">-->
<!--<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>-->
<!--                                                        <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>-->
<!--                                                        <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>-->
<!--                                                        <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>-->
<!--                                                        <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>-->
<!--</svg>-->
<!--                                                </button>-->
<!--                                                <ul class="hide">-->
<!--                                                    <li  v-if="getUserPlaylists">-->
<!--                                                        <label>-->
<!--                                                            <b> Add to ...</b>-->
<!--                                                        </label>-->
<!--                                                    </li>-->
<!--                                                    <li role="separator" class="divider"  v-if="getUserPlaylists"></li>-->
<!--                                                    <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">-->
<!--                                                        <label class="notificationwithcheckboxes">-->
<!--                                                            <input type="checkbox" :checked="verifyVideoExists(playlist, getAuthMoneyVideos[1])" @click="setPlaylistVideoStatus(getAuthMoneyVideos[1], playlist, verifyVideoExists(playlist, getAuthMoneyVideos[1])) "/> {{playlist.title}}-->
<!--                                                            <transition name="fade">-->
<!--                                                                &lt;!&ndash;<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>&ndash;&gt;-->
<!--                                                                <span class="added" v-if="getAuthMoneyVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>-->
<!--                                                            </transition>-->
<!--                                                            <transition name="fade">-->
<!--                                                                <span class="removed" v-if="getAuthMoneyVideos[1].mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>-->
<!--                                                            </transition>-->
<!--                                                        </label>-->
<!--                                                    </li>-->
<!--                                                    &lt;!&ndash;<li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<input type="checkbox" /> Second option&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<input type="checkbox" /> Third option&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<li>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;<input type="checkbox" /> Forth option&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</label>&ndash;&gt;-->
<!--                                                    &lt;!&ndash;</li>&ndash;&gt;-->
<!--                                                    <li role="separator" class="divider" v-if="getUserPlaylists"></li>-->
<!--                                                    <li><label style="color:#f0617d">Create new playlist</label></li>-->
<!--                                                    <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />-->
<!--                                                        <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>-->

<!--                                                    </label> </li>-->
<!--                                                </ul>-->
<!--                                                <div class="backdropformenu"  @click="hidePlaylistMenu('moneyVideo2')"></div>-->
<!--                                            </div>-->
<!--                                            <p class="right-heart-icon">-->
<!--                                                <a href="javascript:" @click="setVideoStatus(getAuthMoneyVideos[1])" title ="Liked this video?">-->
<!--                                                    <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"-->
<!--                                                       v-bind:class="{'activeIcons': getVideoStatus(getAuthMoneyVideos[1])}" aria-hidden="true" ></i></a>-->
<!--                                            </p>-->
<!--                                            &lt;!&ndash;<div v-if="getVideoStatus(getAuthMoneyVideos[1])">&ndash;&gt;-->
<!--                                            &lt;!&ndash;<i class="fa fa-heart fa-2x" aria-hidden="true"></i>&ndash;&gt;-->
<!--                                            &lt;!&ndash;</div>&ndash;&gt;-->
<!--                                            &lt;!&ndash;<div v-else>&ndash;&gt;-->
<!--                                            &lt;!&ndash;<i class="fa fa-2x fa-heart-o" aria-hidden="true" @click=""></i>&ndash;&gt;-->
<!--                                            &lt;!&ndash;</div>&ndash;&gt;-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="panel panel-default">-->
<!--                                    <div class="panel-body no-padding">-->
<!--                                        <div class="col-md-12 margin-top-20 margin-bottom-40 watch-all">-->
<!--                                            <router-link  :to="{ path: '/money'}">-->
<!--                                                See &nbsp;All &nbsp;Money &nbsp;<span class="fa fa-angle-double-right fa-2x" aria-hidden="true"></span>-->
<!--                                            </router-link>-->
<!--                                            &lt;!&ndash;<a href="#/money">See &nbsp;All &nbsp;Money &nbsp;</a><span class="fa fa-angle-double-right fa-2x" aria-hidden="true"></span>&ndash;&gt;-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="showModal" effect="zoom" :value="showModal" @cancel="cancelModal()" width="400">
            <div slot="modal-header">
            </div>
            <div slot="modal-body" class="modal-body">
                <jwplayer :data="currentPlayerID">Loading the player...</jwplayer>
            </div>
            <div slot="modal-footer">
                <p v-if="currentVideoDesc">
                    {{currentVideoDesc}}
                </p>
                <p>
                    <social-sharing v-bind:url="videoURL"  v-bind:quote = "quoteReference" v-bind:description = "quoteReference" v-bind:title = "quoteReference" inline-template>
                        <div>
                            <network network="facebook">
                                <i class="fa fa-2x fa-facebook cursor"></i>
                            </network>
                            <network network="twitter">
                                <i class="fa fa-2x fa-twitter cursor"></i>
                            </network>
                            <network network="linkedin" class="holder">
                                <i class="fa fa-2x fa-linkedin cursor"></i>
                            </network>
                            <network network="email" class="holder">
                                <i class="fa fa-2x fa-envelope cursor"></i>
                            </network>
                        </div>
                    </social-sharing>
                </p>
            </div>
        </modal>
        <modal v-if="showCorporateImageShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateImageShare" @cancel="cancelCorporateImageModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a href="javascript:" @click="cancelCorporateImageModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate">Share with Community</option>
                            <option value="Individual">Share with Colleagues</option>
                            <option value="Friends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="shareEventSelected.img_url" :alt="shareEventSelected.title" :title="shareEventSelected.title">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${shareEventSelected.title} | TONE Networks`}}</h4>
                        <p> {{`${shareEventSelected.longDescription.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateImageModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) " @click="shareCorporateImage()">
                            Share This Event
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import { tabs, tab, modal, spinner } from 'vue-strap'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import { dateHelpers } from '../helpers/dateHelpers.js'

    export default {
        name: 'hello',

        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        components: {
            jwplayer,
            'jwplaylist': JwPlayList,
            'tabs': tabs,
            'tab': tab,
            modal: modal,
            spinner
        },
        data: function () {
            return {
                shareImagePayload: {
                    corporationId: 0,
                    senderUserId: 0,
                    recipientsUserIds: [],
                    recipientFriendEmails: null,
                    eventId: '',
                    customizedMessage: '',
                    playlistType: 6
                },
                shareEventSelected: null,
                showCorporateImageShare: false,
                corporateShareMessage: '',
                selectedPlaylist: null,
                corpShareModalImage: '',
                showCorporateShare: false,
                corpShareModalTitle: '',
                corpShareModalDesc: '',
                selectedCorps: [],
                allCorps: [],
                shareOption: 'Corporate',
                spinner: false,
                taggedEmails: [],
                emailList: [],
                previewMsg: 'Message Preview: \n',
                showSharedModal: false,
                shareInProcess: false,
                hoverState: false,
                showModal: false,
                currentVideo: null,
                currentPlayerID: null,
                currentVideoDesc: '',
                showQuestionsBox: false,
                activeTab: 0,
                expertsToShow: '',
                selectedQuestionId: 0,
                selectedQuestionStatus: false,
                selectedQuestionAnswer: 0,
                recommendedVideoCount: '',
                welcomeMessage: '',
                workTag: 1,
                mindbodyTag: 3,
                lifeTag: 2,
                moneyTag: 4,
                sectionToHide: Math.floor(Math.random() * 3) + 1,
                quoteReference: '',
                newContentLoaded: false,
                videoURL: window.location.href,
                firstTalkEvent: '',
                firstLiveEvent: null,
                liveEventExpert: '',
                eventURL: 'https://www1.dev-tonenetworks.com',
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 0,
                    isAnonymous: 0
                },
                newPlaylistName: '',
                videoAdded: false,
                videoRemoved: false,
                selectedVideo: 0,
                selecedPlaylist: 0,
                appNavigationURL: 'https://s3.amazonaws.com/tone-assets/app/navigation',
                videoRef: null,
                giftingTitle: 'Give the gift of TONE',
                whatIsItImage: 'https://cdn.jwplayer.com/thumbs/maViy4Eq-720.jpg',
                whatIsItHeading: 'What is it?',
                whatIsItText: 'lease join our Community of women helping women as we explore the topics that interest you in our scheduled events. TONE Talks, our open chat groups, and TONE Live, our interactive expert live streaming events, are a great way to get the answers you need to help make it through your busy day!',
                desktopThemes: ['purple', 'orange', 'teal', 'pink'],
                selectedTheme: '',
                metaTag_pageTitle: '',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: ''
            }
        },
        methods: {
            formattedDuration (duration) {
                const hours = Math.floor(duration / 3600)
                const minutes = Math.floor((duration % 3600) / 60)
                const seconds = duration % 60
                const formattedHours = hours > 0 ? `${hours}:` : ''
                const formattedMinutes = minutes > 0 ? `${minutes}:` : '0:'
                const formattedSeconds = `${seconds}`
                return `${formattedHours}${formattedMinutes}${formattedSeconds}`
            },
            shareCorporateImage () {
                let self = this
                self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
                self.shareImagePayload.senderUserId = self.user.userId
                self.shareImagePayload.recipientsUserIds = []
                self.shareImagePayload.recipientFriendEmails = null
                self.shareImagePayload.customizedMessage = self.corporateShareMessage
                if (self.shareOption === 'Corporate') {
                    self.shareImagePayload.recipientsUserIds = []
                    self.shareImagePayload.recipientFriendEmails = null
                } else if (self.shareOption === 'Individual') {
                    self.shareImagePayload.recipientFriendEmails = null
                    if (self.selectedCorps && self.selectedCorps.length > 0) {
                        self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(x => {
                            return x.userId
                        })
                    }
                } else if (self.shareOption === 'Friends') {
                    self.shareImagePayload.recipientsUserIds = []
                    let emailArray = self.taggedEmails.map(x => {
                        return x.name
                    })
                    self.shareImagePayload.recipientFriendEmails = emailArray.join(',')
                } else {
                }
                self.shareImagePayload.eventId = self.shareEventSelected.eventId
                self.shareInProcess = true
                // Send the Email
                self.$store.dispatch('CORP_EVENT_SHARE', {payload: self.shareImagePayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$swal({
                            title: 'Event has been shared!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    } else {
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateImageModal()
                    }
                })
            },
            maskEmailAddress (userEmail) {
                let avg, splitted, part1, part2
                splitted = userEmail.split('@')
                part1 = splitted[0]
                let regex = /[^0-9.]/g
                let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
                console.log('maked', maskid)
                avg = part1.length / 2
                part1 = part1.substring(0, (part1.length - avg))
                part2 = splitted[1]
                let maskDomain = part2.split('.')
                return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
            },
            customLabel (option) {
                let findDuplicate = this.allCorps.find(x => {
                    return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
                })
//            console.log('findDuplicate', findDuplicate)
                if (findDuplicate) {
                    let maskedEmail = this.maskEmailAddress(option.email)
                    return `${option.firstName} ${option.lastName} <${maskedEmail}>`
                } else {
                    return `${option.firstName} ${option.lastName}`
                }
            },
            openCorporateImageShareModal (tEvent) {
                console.log('event for share', tEvent)
                let self = this
                self.shareInProcess = false
                self.shareEventSelected = tEvent
                self.showCorporateImageShare = true
            },
            verifyEmailShare (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            addTag (newTag) {
                let self = this
                console.log('newTAg', newTag)
                const tag = {
                    name: newTag
                }
                if (self.verifyEmailShare(newTag)) {
                    self.emailList.push(tag)
                    this.taggedEmails.push(tag)
                    console.log('tagged emails', this.taggedEmails)
                } else {
                    console.log('invalid email address, calling swal')
                    // self.$swal({
                    //     title: 'Invalid Email Address',
                    //     text: 'Please enter valid email address',
                    //     type: 'error',
                    //     timer: 2000,
                    //     showCancelButton: false,
                    //     showConfirmButton: false
                    // }).then(
                    //     function () {
                    //     },
                    //     // handling the promise rejection
                    //     function (dismiss) {
                    //         if (dismiss === 'timer') {
                    //         }
                    //     }
                    // )
                }
            },
            cancelCorporateImageModal () {
                $('html').removeClass('model-open')
                var self = this
                window.setTimeout(function () {
                    self.showCorporateImageShare = false
                    self.shareInProcess = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            updateHoverState (isHover) {
                this.hoverState = isHover
            },
            calendarLogging (event, title) {
                // console.log('event was fired', event)
                // console.log('event title', title)
                let self = this
                let userPayload = []
                let uId = 0
                if (self.user) {
                    uId = self.user.userId
                }
                userPayload.push(uId)
                userPayload.push(self.$route.fullPath)
                userPayload.push('ADD_TO_CALENDAR')
                userPayload.push(title)
                self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload)
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            socialClick () {
            },
            openModal (videoObj) {
                this.currentPlayerID = {video: videoObj.sources[videoObj.sources.length - 1].file, title: videoObj.title, img: videoObj.image, playerID: new Date(), tracks: videoObj.tracks}
                this.showModal = true
                this.currentVideoDesc = videoObj.description
            },
            cancelModal () {
                var self = this
                var $ = window.jQuery
                setTimeout(function () {
                    self.showModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            showQuestions () {
                if (!this.showQuestionsBox) {
                    window.logEvents('Home Page', 'click', 'In the mood for something else clicked')
                }
                this.showQuestionsBox = !this.showQuestionsBox
            },
            create () {
                $.slick = slick
                const $charitySlick = $(this.$el).find('.responsive-slick-charity-slider')
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $charitySlick.slick({
                    dots: false,
                    infinite: true,
                    useTransform: false,
                    adaptiveHeight: true,
                    speed: 300,
                    pauseOnFocus: true,
                    pauseOnHover: true,
                    // autoplay: true,
                    // autoplaySpeed: 10000,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
                $slick.slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            },
            destroy () {
                $(this.$el).find('.responsive-slick-slider').slick('unslick')
            },
            reSlick () {
                this.destroy()
                this.create()
            },
            redirectToExpert (expertId) {
                this.$router.push(`/expert/${expertId}`)
            },
            getVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0 && exists[0].liked === '1') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setVideoPlayerObject (videoCode, videoTitle) {
                this.$router.push(`/watch/${videoCode}/${videoTitle.replace(/\\s/g, '-').toLowerCase()}`)
            },
            setRecentlyWatchedVideos () {
                this.$router.push(`/recenltywatchedvideos`)
            },
            redirectToGiving () {
                this.$router.push(`/giving`)
            },
            getTimeOfDay () {
                let today = new Date()
                let curHr = today.getHours()

                if (curHr < 12) {
                    return 'morning'
                } else if (curHr < 18) {
                    return 'afternoon'
                } else {
                    return 'evening'
                }
            },
            setAnswer (questionId) {
                if (this.selectedQuestionId !== questionId) {
                    this.spinnerToggle()
                    this.selectedQuestionId = questionId
                    this.selectedQuestionStatus = true
                    let questionResponse = {
                        questionId: questionId,
                        userId: this.user.userId,
                        answer: '1',
                        answerDate: new Date(),
                        answerDescription: null
                    }
                    this.$store.dispatch('SETANSWER', questionResponse).then(() => {
                        this.showQuestionsBox = false
                        this.spinnerToggle()
                        this.newContentLoaded = true
                        window.scrollTo(0, 0)
                        setTimeout(() => {
                            this.newContentLoaded = false
                        }, 3000)
                        // this.recommendedVideos = this.getAuthRecommendedVideos
                    })
                }
            },
            toggleBottonSection (sectionId) {
                if (sectionId === this.sectionToHide) {
                    return true
                }
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay.toString() + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr.toString() + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr.toString() + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr.toString() + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr.toString() + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr.toString() + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            isUserEntrolled (eventId) {
                if (this.getUserEvents) {
                    let filter = this.getUserEvents.filter(ev => {
                        return ev.eventId === eventId
                    })
                    if (filter && filter.length > 0) {
                        return true
                    }
                }
                return false
            },
            isEventToday (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                let eventEndDate = new Date(endDate)
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            showJoin (eventId) {
                let event = this.getEventList.filter(evn => {
                    return evn.eventId === eventId
                })
                if (this.isEventToday(event[0].start_date, event[0].end_date, event[0].eventSwitchTime, this.getEventSwitchTime)) {
                    return true
                }
                return false
            },
            joinEvent (event) {
                this.$router.push(`/event`)
                // this.$router.push(`/rules/` + event.eventId)
            },
            enrollUser (event) {
                if (this.activeTab === 1) {
                    window.logEvents('Home Page', 'Tone Talks Seat Reserved', `Event Title: ${event.title}`)
                } else if (this.activeTab === 2) {
                    window.logEvents('Home Page', 'Tone Live Seat Reserved', `Event Title: ${event.title}`)
                }
                this.seatReservation.eventId = event.eventId
                this.seatReservation.userId = this.user.userId
                this.seatReservation.status = '1'
                this.seatReservation.isAnonymous = '0'
                this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(() => {
                    this.$store.dispatch('GETALLEXPERTS').then(() => {
                    })
                    this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                    })
                })
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                return serverDate
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            },
            setVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0) {
                        if (exists[0].liked === '1') {
                            exists[0].liked = '0'
                        } else {
                            exists[0].liked = '1'
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    } else {
                        let logWatchedEntry = {
                            videoCode: videoObject.mediaid,
                            userId: this.user.userId,
                            playlistId: null,
                            playlistCode: null,
                            watched: 'N',
                            rating: null,
                            liked: '1',
                            durationWatched: 0,
                            thumbnailURL: null,
                            opinion: null
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    }
                }
            },
            setPlaylistVideoStatus (video, playlist, currentStatus) {
                let self = this
                self.selectedVideo = video.mediaid
                self.selectedPlaylist = playlist.playlistId
                if (currentStatus) { // Video is unSelected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userPlaylistId = playlist.playlistId
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        self.videoAdded = false
                        self.videoRemoved = true
                    })
                } else { // Video is Selected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userId = this.user.userId
                    payload.userPlaylistId = playlist.playlistId
                    this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                        // this.charities = this.getAuthUserVideos
                        self.videoAdded = true
                        self.videoRemoved = false
                    })
                }
                setTimeout(() => {
                    self.videoAdded = false
                    self.videoRemoved = false
                }, 1500)
            },
            verifyPlaylistExists () {
                if (this.getUserPlaylists) {
                    let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                        return x.userPlaylistVideos !== null
                    })
                    if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            verifyVideoExists (playlist, video) {
                let self = this
                if (this.getUserPlaylists) {
                    let findPlaylist = this.getUserPlaylists.filter(x => {
                        return x.playlistId === playlist.playlistId
                    })
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                            let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                                return x.videoCode === video.mediaid
                            })
                            if (videos && videos.length > 0) {
                                self.playlistHasVideo = true
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            addNewPlayList () {
                if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                    let payload = {}
                    payload.userId = this.user.userId
                    payload.title = this.newPlaylistName
                    this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                        this.newPlaylistName = ''
                        // this.charities = this.getAuthUserVideos
                    })
                }
            },
            getRandomTheme () {
                let randomIndex = Math.floor(Math.random() * this.desktopThemes.length)
                return this.desktopThemes[randomIndex]
            },
            showPlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            hidePlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            isHidden () {
                // let self = this
                console.log('isHidden () = ', this.user && this.user.corporation && this.user.corporation.corporationId === 200)
                return this.user && this.user.corporation && this.user.corporation.corporationId === 200
            },
            buildEventLink (EVENT_ID) {
                let href = window.location.href
                let calendarLink = ''
                console.log('Community.vue -> buildEventLink() : href = ', href)
                console.log('Community.vue -> buildEventLink() : EVENT_ID = ', EVENT_ID)
                if (this.user && this.user.corporation && this.user.corporation.corporationId === 200) {
                    if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
                        calendarLink = 'https://www1.dev-tonenetworks.com/horizonssotest?corporationId=200&redirect_uri=https://www1.dev-tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                    } else {
                        calendarLink = 'https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                    }
                    //  https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/294
                } else {
                    calendarLink = this.eventURL + '/event/' + EVENT_ID // this.getMainEvent.eventId
                    // https://www.tonenetworks.com/event/294
                }
                return calendarLink
            }
        },
        mounted: function () {
            let self = this
            self.$store.dispatch('GETDYNAMICCONTENTS', 16).then(() => {
                if (self.getAllSiteContents) {
                    // Load Meta Tags
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                }
            })
            if (navigator.userAgent.indexOf('gonative') > -1) {
                let info = {userId: self.user.userId}
                let jsonFile = ''
                if (self.user.corporation && self.user.corporation.enableCorporatePage === 1) {
                    jsonFile = 'sidebar_auth_corp.json'
                } else {
                    jsonFile = 'sidebar_auth.json'
                }
                var json = JSON.stringify(info)
                window.location.href = `gonative://registration/send?customData=${encodeURIComponent(json)}`
                // Get auth Navigation bar
                $.getJSON(`${self.appNavigationURL}/${jsonFile}`, function (data) {
                    console.log('side navigation (uath) returned', data)
                    var json = JSON.stringify(data)
                    window.location.href = 'gonative://sidebar/setItems?items=' + encodeURIComponent(json)
                }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })

                if (navigator.userAgent.indexOf('gonativeand') <= -1) {
                    // Get auth Bottom bar - not for android
                    setTimeout(function () {
                        $.getJSON(`${self.appNavigationURL}/bottomNav_auth.json`, function (data) {
                            console.log('bottom navigation (auth) returned', data)
                            var json = JSON.stringify(data)
                            window.location.href = 'gonative://tabs/setTabs?tabs=' + encodeURIComponent(json)
                        }).fail(function (jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus + '  :  ' + errorThrown) })
                    }, 500)
                }
            }
            if (self.user && self.user.trialEndDate) {
                let endingDate = new Date(self.user.trialEndDate.substr(0, 10))
                let currentDate = new Date()
                let remainingDays = dateHelpers.getDatesDifference(endingDate, currentDate, 'days')
                if (remainingDays < 0) {
                    self.$router.push('/becomemember')
                }
            }
            // Retreive recommended videos
            this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(() => {
                // this.recommendedVideos = this.getAuthRecommendedVideos
                // console.log('recommended videos', this.getAuthRecommendedVideos)
                if (this.getAuthRecommendedVideos) {
                    if (this.getAuthRecommendedVideos.length >= 3) {
                        this.recommendedVideoCount = 'three'
                    } else if (this.getAuthRecommendedVideos.length === 2) {
                        this.recommendedVideoCount = 'two'
                    } else if (this.getAuthRecommendedVideos.length === 1) {
                        this.recommendedVideoCount = 'one'
                    } else {
                        this.recommendedVideoCount = 'none'
                    }
                }
            })
            // Get User Liked Videos
            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(() => {
                // this.charities = this.getAuthUserVideos
            })
            // Retreive Recently watched videos
            this.$store.dispatch('GETAUTHRECENTLYWATCHEDVIDEOS', this.user.userId).then(() => {
                setTimeout(() => {
                    this.create()
                }, 3000)
                this.recentlyWatchedVideos = this.getAuthRecentlyWatchedVideos
            })
            // Retreive Charities
            this.$store.dispatch('GETALLCHARITIES').then(() => {
                // console.log('charities:', this.getAllCharities)
                // this.charities = this.getAllCharities
            })
            this.$store.dispatch('GETDYNAMICCONTENTS', 16).then(() => {
                if (this.getAllSiteContents) {
                    this.whatIsItImage = this.setDynamicSection(this.getAllSiteContents, 'WHAT_IMG_URL')
                    this.whatIsItHeading = this.setDynamicSection(this.getAllSiteContents, 'WHAT_HEADING')
                    this.whatIsItText = this.setDynamicSection(this.getAllSiteContents, 'WHAT_TEXT')
                }
            })
            // Get Career Videos
            let corpId = 0
            if (self.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId
            }
            let params = ['WORK', corpId]
            this.$store.dispatch('GETAUTHVIDEOS', params).then(() => {
                // console.log('career:', this.getAuthCareerVideos)
                // this.charities = this.getAllCharities
            })
            params = []
            params = ['MINDBODY', corpId]
            // Get Mindbody videos
            this.$store.dispatch('GETAUTHVIDEOS', params).then(() => {
                // console.log('mindbody:', this.getAuthMindbodyVideos)
                // this.charities = this.getAllCharities
            })
            // Get Inspiration Videos
            params = []
            params = ['LIFE', corpId]
            this.$store.dispatch('GETAUTHVIDEOS', params).then(() => {
                // console.log('inspiration:', this.getAuthInspirationVideos)
                // this.charities = this.getAllCharities
            })
            params = []
            params = ['MONEY', corpId]
            this.$store.dispatch('GETAUTHVIDEOS', params).then(() => {
                // console.log('inspiration:', this.getAuthInspirationVideos)
                // this.charities = this.getAllCharities
            })
            // Get Questions
            this.$store.dispatch('GETAUTHQUESTIONS').then(() => {
                // console.log('questions', this.getAuthQuestions)
            })
            // Get Funnies
            this.$store.dispatch('GETAUTHFUNNIES', corpId).then(() => {
            })
            // Get Greetings
            this.$store.dispatch('GETAUTHGREETNGS', corpId).then(() => {
            })
            // Get Quote
            this.$store.dispatch('GETAUTHQUOTES', corpId).then(() => {
                this.quoteReference = this.getQuote.quote + '  (' + this.getQuote.author + ')'
                // console.log(this.quoteReference)
            })
            // Get Experts
            this.$store.dispatch('GETALLEXPERTS').then(() => {
                // console.log('experts', this.getAllExperts)
                this.expertsToShow = this.getAllExperts.slice(0, 3)
            })
            // Get Event List
            this.$store.dispatch('GETEVENTLIST').then(() => {
                if (this.getEventList) {
                    let liveEvent = this.getEventList.filter(ev => {
                        return ev.type === '1'
                    })
                    this.firstLiveEvent = liveEvent[0]
                    if (this.getAllExperts && this.firstLiveEvent && this.firstLiveEvent.expertId > 0) {
                        let expert = this.getAllExperts.filter(exp => {
                            return exp.expertId === this.firstLiveEvent.expertId
                        })
                        this.liveEventExpert = expert[0]
                    }
                    let talkEvent = this.getEventList.filter(ev => {
                        return ev.type === '2'
                    })
                    this.firstTalkEvent = talkEvent[0]
                    setTimeout(function () {
                        window.addeventatc.refresh()
                    }, 2000)
                }
            })
            setTimeout(() => {
                let randomIndex = Math.floor(Math.random() * this.desktopThemes.length)
                this.selectedTheme = this.desktopThemes[randomIndex]
            }, 500)
            // Get User Events
            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
            })
            // Get User Playlists
            this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(() => {
                // this.charities = this.getAuthUserVideos
            })
            if (this.user) {
                // Get Tagged Email List
                self.$store.dispatch('GET_TAGGED_EMAIL_LIST', self.user.userId).then(() => {
                    if (self.getTaggedEmailList) {
                        self.emailList = []
                        self.emailList = self.getTaggedEmailList
                        console.log('email list', self.getTaggedEmailList)
                    }
                })
                // Get Corporatin Payload if user is part of corporation
                this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                    this.allCorps = []
                    if (this.getCorporatePayload) {
                        this.corporateInfo = this.getCorporatePayload
                        this.allCorps = this.corporateInfo.lstCorporationUsers
                    }
                })
            }
            this.$root.$on('social_shares_open', function (network, url) {
                window.logEvents('Home Page', 'social share', `Quote shared on: ${network}`)
            })
        },
        watch: {
            'activeTab' (to, from) {
                if (to === 1) {
                    window.logEvents('Home Page', 'click', 'Tone Talks tab Clicked')
                } else if (to === 2) {
                    window.logEvents('Home Page', 'click', 'Tone Live tab Clicked')
                } else {
                }
            },
            'firstLiveEvent' (to, from) {
                let self = this
                if (self.firstLiveEvent && self.firstLiveEvent.eventId > 0) {
                    if (self.firstLiveEvent.jw_stream_title && self.firstLiveEvent.jw_stream_title.length > 2) {
                        self.$store.dispatch('GETCURRENTVIDEO', self.firstLiveEvent.jw_stream_title).then(() => {
                            if (self.getCurrentVideo) {
                                let videoObj = self.getCurrentVideo[0]
                                self.currentVideo = {
                                    video: videoObj.sources[videoObj.sources.length - 1].file,
                                    title: videoObj.title,
                                    img: videoObj.image,
                                    playerID: new Date(),
                                    tracks: videoObj.tracks,
                                    Description: videoObj.description,
                                    mediaId: videoObj.mediaid,
                                    isMute: true,
                                    autoStart: false
                                }
//                                self.videoRef = window['currentVideoId']
                                setTimeout(() => {
                                    this.videoRef = window['currentVideoId']
                                    window.jwplayer(this.videoRef).seek(1)
                                    window.jwplayer(this.videoRef).pause(true)
                                }, 500)
                            }
                        })
                    }
                } else {
                }
            }
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'user', 'error', 'isScrolled', 'getAuthRecommendedVideos', 'getAuthRecentlyWatchedVideos', 'getAllCharities', 'getAuthWorkVideos',
                'getAuthMindbodyVideos', 'getAuthLifeVideos', 'getAuthQuestions', 'getAllExperts', 'getAuthUserVideos', 'getQuote', 'getAuthMoneyVideos', 'getAuthGreeting',
                'getAuthFunnies', 'getEventList', 'getUserEvents', 'getUserPlaylists', 'getEventSwitchTime', 'getCurrentVideo', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getTaggedEmailList', 'getCorporatePayload', 'getAllSiteContents'],
            ),
            styleObject () {
                if (this.hoverState) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor,
                        borderColor: this.getCorpButtonColor
                    }
                } else {
                    return {
                        // border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor,
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: this.getCorpButtonColor
                    // borderColor: this.getCorpButtonColor
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .align-to-bottom {
        //bottom: -10px !important;
        right: 0px !important;
    }

    .jw-img-1 {
        max-width: 100%; /* Ensure the image does not exceed its container width */
    }

    .image-container {
        position: relative;
        display: flex;
        justify-content: space-between;
    }
    .postion-title{
        position: absolute;
        bottom: 8px;
    }

    .text-wrap-title-1 {
        right: -14px;
        position: absolute;
        background-color: rgb(68, 189, 168) !important;
        color: #fff;
        padding: 2px 4px;
        font-size: 12px;
        border-top-left-radius: 4px;
        line-height: 1.1 !important;
    }
    .recent-style {
        top: 60px !important;
    }

    .slick-slide img {
        width: 100%;
        /*height: 200px;*/
        object-fit: contain;
        margin-top:70px;
        margin-bottom:70px;
    }
    @media(max-width:992px){
        .slick-slide img {
            margin: 10px 0;
        }
    }
    .funnies-img img{
        width: auto;
        margin: 0 auto;
        object-fit: contain;
    }
    .funnies-img.smallslide>img {
        height: 380px;
    }
    .newcontentloaded {
        color: #f0617d;
        text-transform: capitalize;
        margin: 7px 0 25px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .funnies-img.smallslide>img.bgimgfunny {
        object-fit: cover;
    }
    .hello-page-wrapper .recently-watched {
        margin-bottom: 50px;
    }
    @media (min-width:768px) {

        .hello-page-wrapper .recently-watched .jw-img {
            MARGIN-TOP: 0;
            margin-bottom: 0;
        }
    }
    @media(max-width:767px){
        .funnies-img.smallslide>img.bgimgfunny {
            display:none;
        }
    }
    .hello-page-wrapper .random .blog-section .panel i.fa.fa-play-circle-o {
        position: static;
        color:#666;
        height: auto !important;
        width: auto !important;
    }

    .hello-page-wrapper .random .blog-section .panel {
        text-align: left;
    }
    .hello-page-wrapper .expert-section .experts {
        margin-top: 0em;
    }
    .experts.teal {
        background-color: teal;
        color: #fff;
        padding: 20px;
        text-align: center;
    }

    .experts.teal h2 {
        color: #fff;
        text-align: center;
    }

    .hello-page-wrapper .expert-section .experts.teal p {
        color: #fff;
        text-align: center;
        line-height: 1.3;
    }
    .hello-page-wrapper .main-content hr{
        float:left;
    }
    .hello-page-wrapper .main-content hr+span{
        display:block;
        clear:both;
    }
    .btn-group.plusicon {
        position: absolute;
        left: 15px;
        bottom: -35px;
        height: 29px;
    }
    button.dropdown-toggle.ellipsis.pull-right i {
        color: #333;
    }
    .random-section-head .btn-group.plusicon {
        left: auto;
        right: 50px;
        bottom: -32px;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right{
        font-size: 21px;
        top: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right li label{
        padding: 30px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 0px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size: 24px;
        right: 7px;
        cursor: pointer;
        height: auto !important;
        width: auto !important;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label {
        margin: 0;
    }

    .slick-slide button.dropdown-toggle.ellipsis.pull-right+ ul {
        overflow-y: auto;
        max-height: 250px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul{
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        left: auto ;
        right: 0;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }
    .hello-page-wrapper .random .blog-section .panel label.notificationwithcheckboxes span {
        font-size: 10px;
        position: static;
    }
    .imgbalnace .col-md-6 img {
        margin: 0;
    }
    .imgbalnace .col-md-6{
        padding-top:70px;
    }
    section.applicationdownload {
        padding: 300px 20px 30px;
        background-image: url(https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/app-image-resized-new.png);
        background-size: cover;
        background-position: center;
        position: relative;
    }

    section.applicationdownload img.showmobile {
        display: none;
    }

    section.applicationdownload b {
        color: #fff;
    }

    section.applicationdownload:after {
        content: "";
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.35);
    }

    section.applicationdownload>* {
        position: relative;
        z-index: 1;
    }

    section.applicationdownload h2 {
        font-family: Zilla Slab,serif;
        font-size: 45px!important;
        font-style: normal;
        margin: 0 0 140px;
    }


    section.applicationdownload .appbtn {
        max-width: 220px;
        margin: 0 25px;
    }
    @media(max-width:768px) {
        section.applicationdownload .appbtn {
            max-width: 220px;
            margin: 0 10px;
        }

        section.applicationdownload img.showmobile {
            display: block;
            width: 100%;
        }

        section.applicationdownload {
            padding: 0 0 50px;
            background: #fff;
        }

        section.applicationdownload h2 {
            margin: 40px 0;
            color: #000;
            padding: 0 20px;
        }

        section.applicationdownload:after {
            display: none;
        }

        section.applicationdownload h2 b {
            color: #000;
            font-size: 34px !important;
        }
    }
    @media(max-width:767px){
        p.right-heart-icon {
            margin-bottom: 37px;
        }

        .random-section-head .btn-group.plusicon{
            bottom: -40px;
        }
        .slick-slider {
            margin-bottom: 70px;
        }
        .funnies-img.smallslide>img {
            max-width: 100%;
        }
    }

    .showMobile {
        display: none;
    }

    @media(max-width:767px){
        .hidemobile {
            display: none !important;
        }
        .showMobile {
            display: block;
        }


    }

    .theme-bg-img {
        background-color: #f4f4f4;
        background-image: none !important;
        color: #000;
    }

    .hello-page-wrapper .theme-bg-img .main-content h2 {
        color: #000;
    }
    .coloredpannel {
        padding: 20px 20px 0px;
    }

    .hello-page-wrapper .left-panel .high-lighter {
        background: none;
        color: #343434;
    }

    .hello-page-wrapper .left-panel i.fa {
        color: #adadad !important;
    }
    .hello-page-wrapper .left-panel i.fa.fa-play-circle-o {
        color: #000 !important;
    }

    .hello-page-wrapper .left-panel h4 {
        color: #8e8e8e;
        margin: 0 0 50px;
    }

    .hello-page-wrapper .purple.theme-bg-img .main-content h2 b {
        color: #93688e
    }

    .purple .coloredpannel {
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#93688e+0,ffffff+100 */
        background: #93688e; /* Old browsers */
        background: -moz-linear-gradient(top,  #93688e 0%, #ffffff 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top,  #93688e 0%,#ffffff 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,  #93688e 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#93688e', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */

    }

    .hello-page-wrapper .theme-bg-img.purple .right-panel .interest-mood {
        background-color: #93688e
    }



    .hello-page-wrapper .orange.theme-bg-img .main-content h2 b {
        color: #faa51e
    }

    .orange .coloredpannel {
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#faa51e+0,ffffff+100 */
        background: #faa51e; /* Old browsers */
        background: -moz-linear-gradient(top,  #faa51e 0%, #ffffff 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top,  #faa51e 0%,#ffffff 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,  #faa51e 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#faa51e', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */

    }

    .hello-page-wrapper .theme-bg-img.orange .right-panel .interest-mood {
        background-color: #faa51e
    }



    .hello-page-wrapper .teal.theme-bg-img .main-content h2 b {
        color: #44bda8
    }

    .teal .coloredpannel {
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#44bda8+0,ffffff+100 */
        background: #44bda8; /* Old browsers */
        background: -moz-linear-gradient(top,  #44bda8 0%, #ffffff 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top,  #44bda8 0%,#ffffff 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,  #44bda8 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#44bda8', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */

    }

    .hello-page-wrapper .theme-bg-img.teal .right-panel .interest-mood {
        background-color: #44bda8
    }



    .hello-page-wrapper .pink.theme-bg-img .main-content h2 b {
        color: #f0617d
    }

    .pink .coloredpannel {
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#93688e+0,ffffff+100 */
        background: #93688e; /* Old browsers */
        background: -moz-linear-gradient(top,  #f0617d 0%, #ffffff 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top,  #f0617d 0%,#ffffff 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom,  #f0617d 0%,#ffffff 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f0617d', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */

    }

    .hello-page-wrapper .theme-bg-img.pink .right-panel .interest-mood {
        background-color: #f0617d
    }

    .shadowdrop {
        box-shadow: 0 11px 15px rgba(0,0,0, 0.25);
    }

    .questions-content {
        background: white;
        color: #fff;
        border: 1px solid #ddd;
    }
    .hello-page-wrapper .main-content hr {
        border-color: #343434;
    }
    button.share-event {
        color: rgb(240, 97, 125) !important;
        border: 1px solid rgb(240, 97, 125) !important;
        background-image: none !important;
        font-weight: 600;
        line-height: 100%;
        background: #fff !important;
        font-size: 15px !important;
        text-decoration: none;
        border-radius: 3px !important;
        cursor: pointer;
        -webkit-font-smoothing: antialiased!important;
        outline-color: rgba(0,78,255,0.5) !important;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);
        display: inline-block;
        position: relative;
        /*z-index: 99998;*/
        font-family: "Open Sans",Roboto,"Helvetica Neue",Helvetica,Optima,Segoe,"Segoe UI",Candara,Calibri,Arial,sans-serif !important;
        padding: 12px 12px 12px 12px !important;
        margin-left: 10px !important;
        width: 173px !important;
        display: inline-block;
        float: left !important;
        box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;
    }
    .addeventatc.pinkoutlinebtn {
        float: left;
    }
    /*.slick-slide .addeventatc.pinkoutlinebtn {*/
    /*    padding: 13px 12px 12px 37px !important;*/
    /*}*/

    /*.slick-slide button.share-event {*/
    /*    width: auto !important;*/
    /*    margin: 10px;*/
    /*}*/
    @media(max-width:991px){
        .addeventatc.pinkoutlinebtn{
            margin-left:0 !important;
            margin-right:10px;
            margin-bottom:10px;
        }
        button.share-event{
            margin-left:0 !important;
        }
    }
    @media(max-width:767px){
        .addeventatc.pinkoutlinebtn{margin-left:10px !important;}
        button.share-event{
            margin-left:5px !important;
        }
    }
    @media(max-width:991px){
        .addeventatc.pinkoutlinebtn{
            margin-left:0 !important;
            margin-right:10px;
            margin-bottom:10px;
        }
        button.share-event{
            margin-left:0 !important;
        }
    }
    @media(max-width:767px){
        .addeventatc.pinkoutlinebtn{
            margin-left:0px !important;
        }
        button.share-event{
            margin-left:0px !important;
        }
    }
    @media(max-width:991px){
        .addeventatc.pinkoutlinebtn{
            margin-left:0 !important;
            margin-right:10px;
            margin-bottom:10px;
        }
        button.share-event{
            margin-left:0 !important;
        }
    }
    @media(max-width:767px){
        .addeventatc.pinkoutlinebtn{
            margin-left:0px !important;
        }
        button.share-event{
            margin-left:0px !important;
        }
    }
    /*Changes for Corporate Modal*/
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
        .pinksidebarmin{
            padding:0 !important;
            display: flex;
            flex-direction: column;
            flex-basis: auto;
            display: flex ;
            align-items: stretch ;
            justify-content: center;
        }

        .pinksidebarmin > * {
            padding: 6px 0 !important;
            margin: 0 !important;
            flex: 100;
            text-align:center;
        }
    }
    .watchVideoModal .modal-dialog .modal-body p {
        padding: 16px 60px 19px 60px;
    }
    .modal {
        z-index: 999999;
    }
    .addeventatc {
        padding: 12px 12px 12px 37px !important;
    }
</style>
<style>
    .hello-page-wrapper .theme-bg-img .left-panel .container-icons span {
        color:#343434;
    }
    @media(max-width:767px){
        .responsive-slick-charity-slider .slick-list {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// Hello.vue?7169d72c